<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from '@/utils/ugm-swal';
import Multiselect from 'vue-multiselect';
import laborantesEvento from './eventolaborantes.vue';
import pdf from 'vue-pdf';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, laborantesEvento, pdf },
    data() {
        return {
            title: "Eventos",
            items: [
                {
                text: "Configuración",
                href: "/"
                },
                {
                text: "Eventos",
                active: true
                }
            ],
            datoseventos:[],
            eventos:[],
            eventoseleccionada: [],                       //alumna seleccionada en el buscador
            eventoid_seleccion: [],                       //id alumna
            eventoid_seleccion1: [],                       //id alumna
            habilitar_boton: false,
            editing: false,
            originalevento:'',
            tipos_gastos:['Transporte local/Nacional','Transporte Uber','Alimentos/bebidas reuniones','Peaje y estacionamiento','Gasolina','Materiales de oficina','Hospedaje','Viajes Aereos'],
            tipos:[],
            subtipos:[],
            cursos: ['1° medio', '2° medio', '3° medio', '4° medio', 'Egresado'],
            emailError:'',
            phoneerror:'',
            copiado:false,
            isLoading: false,
            uploadProgress: null,
            uploadStreamBuffer: '',
            uploadStreamResponseLength: 0,
            uploadStreamResult: null,
            importacionAsistentes: null,
            importacionAsistentesTimer: null,
            isLoadingAsistentes: false,
            asistentesPage: 1,
            asistentesPerPage: 25,
            asistentesTotal: 0,
            asistentesResultadosTotal: 0,
            asistentesLastPage: 1,
            asistentesSearch: '',
            asistentesSearchTimer: null,
            isDeletingAsistentes: false,
            isSendingPreview: false,
            colegios:[],
            todos_colegios:[],
            usuarios:[],
            subtiposfilter:[],
            estados:['Vigente','Cerrado','Cancelado'],
            estado:'',
            showUploadAsistentes: false,
            selectedAsistentesFile: null,
            asistentesFileKey: 0,
            showGastoForm: false,
            gasto: {
                tipo: null,
                monto: '$0',
                imagen: null
            },
            tipoArchivo: '',
            imagenminiatura: '',
            direccion: '',
            extension: '',
            cambiar: false,
            syncingEventoHubspot: false,
            pagosLaborantesEvento: [],
            valor_editar:{
                tipo: null,
                monto: '$0',
                imagen: null},
            insumosEvento: [],
            colegiosEditSel: [],
            previewCorreoColegioRbd: null,
            showInsumoForm: false,
            insumo: { nombre: '', cantidad: '', unidad: '', observacion: '' },
            isSavingInsumo: false,
            currentEventoRequestToken: 0
        };
    },
    computed:{
        puedeEditarEventos() {
            const rol = this.user && this.user.rol ? String(this.user.rol) : '';
            return ['SuperAdmin', 'Admin', 'Supervisor', 'Coordinador'].includes(rol);
        },
        puedeGestionarDetalleEvento() {
            return this.puedeEditarEventos;
        },
        esDecana() {
            return String(this.user && this.user.rol ? this.user.rol : '') === 'Decana';
        },
        puedeEliminarEventos() {
            return this.puedeEditarEventos && (String(this.user.id) === '6' || String(this.user.id) === '1');
        },
        esUsuarioPermisoEspecialLaborantesInsumos() {
            return String(this.user && this.user.id ? this.user.id : '') === '4';
        },
        puedeGestionarInsumos() {
            return this.puedeGestionarDetalleEvento || this.esUsuarioPermisoEspecialLaborantesInsumos;
        },
        puedeVerPreviewCorreo() {
            const rol = this.user && this.user.rol ? String(this.user.rol) : '';
            return rol !== '' && !['Laborante', 'Decana', 'Gastos'].includes(rol);
        },
        isEmailValid() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.eventoid_seleccion.correo_notificaciones);
        },
        pagosLaborantesPagados() {
            return (this.pagosLaborantesEvento || []).filter(item => item.estado === 'Pagado');
        },
        gastosEvento() {
            if (!this.eventoid_seleccion1 || !Array.isArray(this.eventoid_seleccion1.gastos)) {
                return [];
            }
            return this.eventoid_seleccion1.gastos;
        },
        esDiaInicioEvento() {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.fecha_inicio) {
                return false;
            }
            const fechaInicio = String(this.eventoid_seleccion1.fecha_inicio).slice(0, 10);
            const hoy = new Date();
            const hoyFormato = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;
            return hoyFormato >= fechaInicio;
        },
        asistentesYaCargados() {
            return this.asistentesTotal > 0
                || !!(this.eventoid_seleccion1 && Array.isArray(this.eventoid_seleccion1.asistentes) && this.eventoid_seleccion1.asistentes.length);
        },
        importacionAsistentesActiva() {
            return !!(this.importacionAsistentes && ['queued', 'processing'].includes(this.importacionAsistentes.estado));
        },
        asistentesAlmacenados() {
            if (this.asistentesTotal > 0) {
                return this.asistentesTotal;
            }
            if (this.importacionAsistentes && Number.isFinite(Number(this.importacionAsistentes.almacenados))) {
                return Number(this.importacionAsistentes.almacenados);
            }
            return this.eventoid_seleccion1 && Array.isArray(this.eventoid_seleccion1.asistentes)
                ? this.eventoid_seleccion1.asistentes.length
                : 0;
        },
        mostrarSpinnerAsistentes() {
            return this.isLoadingAsistentes && this.asistentesYaCargados;
        },
        asistentesDetalle() {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.asistentes_por_curso) return {};
            try {
                const raw = this.eventoid_seleccion1.asistentes_por_curso;
                return typeof raw === 'string' ? JSON.parse(raw) : raw;
            } catch (e) { return {}; }
        },
        totalAsistentes() {
            return Object.values(this.asistentesDetalle).reduce((sum, v) => sum + (parseInt(v) || 0), 0);
        },
        estadoActividadLabel() {
            const ea = this.eventoid_seleccion1 && this.eventoid_seleccion1.estado_actividad;
            if (!ea) return '';
            if (Array.isArray(ea)) return ea[0]?.nombre || ea[0] || '';
            if (typeof ea === 'object') return ea.nombre || '';
            return ea;
        },
        colegiosDetalleEvento() {
            const evento = this.eventoid_seleccion1;
            if (!evento) return [];

            if (evento.colegios_json) {
                try {
                    const lista = typeof evento.colegios_json === 'string'
                        ? JSON.parse(evento.colegios_json)
                        : evento.colegios_json;

                    if (Array.isArray(lista) && lista.length) {
                        return lista;
                    }
                } catch (e) {}
            }

            if (evento.rbd_colegio || evento.colegio) {
                return [{ rbd: evento.rbd_colegio, nombre: evento.colegio }];
            }

            return [];
        },
        direccionesColegiosDetalle() {
            if (!this.colegiosDetalleEvento.length) return [];

            return this.colegiosDetalleEvento
                .map((col) => {
                    const colegio = (this.colegios || []).find(c => String(c.rbd) === String(col.rbd));
                    if (!colegio || !colegio.direccion) return null;
                    return {
                        rbd: col.rbd,
                        nombre: col.nombre,
                        direccion: colegio.direccion,
                    };
                })
                .filter(Boolean);
        },
        direccionColegio() {
            if (!this.direccionesColegiosDetalle.length) return null;
            return this.direccionesColegiosDetalle[0].direccion;
        },
        eventoTieneColegioFallback() {
            if (!this.eventoid_seleccion1) return false;
            const rbd = String(this.eventoid_seleccion1.rbd_colegio ?? '').trim();
            const colegio = String(this.eventoid_seleccion1.colegio ?? '').trim().toLowerCase();
            return rbd === '0' || colegio === 'sin colegio';
        },
        fechaModificacion() {
            if (!this.eventoid_seleccion1) return null;
            const upd = this.eventoid_seleccion1.updated_at;
            const cre = this.eventoid_seleccion1.created_at;
            if (!upd || !cre) return null;
            if (upd === cre) return null;
            const d = new Date(upd);
            if (isNaN(d)) return upd;
            const pad = n => String(n).padStart(2, '0');
            return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        }
    },
    methods:{
        normalizeCursoEvento(valor) {
            const normalized = String(valor ?? '')
                .trim()
                .toLowerCase()
                .replace(/\s+/g, ' ');

            const map = {
                '1': '1° medio',
                '1°': '1° medio',
                '1º': '1° medio',
                '1 medio': '1° medio',
                '1° medio': '1° medio',
                '1º medio': '1° medio',
                'primero medio': '1° medio',
                '2': '2° medio',
                '2°': '2° medio',
                '2º': '2° medio',
                '2 medio': '2° medio',
                '2° medio': '2° medio',
                '2º medio': '2° medio',
                'segundo medio': '2° medio',
                '3': '3° medio',
                '3°': '3° medio',
                '3º': '3° medio',
                '3 medio': '3° medio',
                '3° medio': '3° medio',
                '3º medio': '3° medio',
                'tercero medio': '3° medio',
                '4': '4° medio',
                '4°': '4° medio',
                '4º': '4° medio',
                '4 medio': '4° medio',
                '4° medio': '4° medio',
                '4º medio': '4° medio',
                'cuarto medio': '4° medio',
                'egresado': 'Egresado',
                'egresados': 'Egresado',
            };

            return map[normalized] || null;
        },
        normalizeCursosEvento(cursos) {
            let valores = [];

            if (Array.isArray(cursos)) {
                valores = cursos;
            } else if (typeof cursos === 'string') {
                const raw = cursos.trim();
                if (!raw) {
                    return [];
                }

                try {
                    const parsed = JSON.parse(raw);
                    valores = Array.isArray(parsed) ? parsed : raw.split(';');
                } catch (e) {
                    valores = raw.split(';');
                }
            }

            return [...new Set(valores.map((curso) => this.normalizeCursoEvento(curso)).filter(Boolean))];
        },
        esInteraccionSimulador(ev) {
            const nombre = String(
                (ev && (ev.nombre_difusion || ev.nombre || ev.title || '')) || ''
            )
                .trim()
                .toLowerCase();

            return nombre.startsWith('interaccion simulador') || nombre.startsWith('interacción simulador');
        },
        syncHubspotEvento() {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                return;
            }

            this.syncingEventoHubspot = true;
            axios.post('/api/sync_hubspot_evento', { id: this.eventoid_seleccion1.id })
                .then((res) => {
                    if (res.data.estado) {
                        const eventoActualizado = res.data.evento || {};
                        this.eventoid_seleccion1.hubspot_actividad_id = eventoActualizado.hubspot_actividad_id || res.data.hubspot_actividad_id || this.eventoid_seleccion1.hubspot_actividad_id;
                        if (Object.prototype.hasOwnProperty.call(eventoActualizado, 'colegio')) {
                            this.$set(this.eventoid_seleccion1, 'colegio', eventoActualizado.colegio);
                            this.$set(this.eventoid_seleccion, 'colegio', eventoActualizado.colegio);
                        }
                        if (Object.prototype.hasOwnProperty.call(eventoActualizado, 'rbd_colegio')) {
                            this.$set(this.eventoid_seleccion1, 'rbd_colegio', eventoActualizado.rbd_colegio);
                            this.$set(this.eventoid_seleccion, 'rbd_colegio', eventoActualizado.rbd_colegio);
                        }
                        this.cargarAsistentesEvento(this.eventoid_seleccion1.id, this.currentEventoRequestToken);

                        const mensajes = [];
                        if (res.data.colegio_encontrado) {
                            mensajes.push('Se actualizó el colegio asociado.');
                        }
                        if (Number(res.data.contactos_persistidos || 0) > 0) {
                            mensajes.push(`Se guardaron ${res.data.contactos_persistidos} asistentes desde HubSpot.`);
                        } else if (res.data.contactos_encontrados === false) {
                            mensajes.push('No se encontraron asistentes asociados en HubSpot.');
                        }
                        Swal.fire({
                            icon: 'success',
                            title: res.data.mensaje || 'Evento sincronizado con HubSpot.',
                            text: [res.data.warning, ...mensajes].filter(Boolean).join(' '),
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    } else {
                        Swal.fire({
                            icon: 'warning',
                            title: res.data.mensaje || 'No se pudo sincronizar en HubSpot.',
                            text: res.data.detalle || '',
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    }
                })
                .catch((err) => {
                    const detalle = err?.response?.data?.detalle || '';
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al sincronizar con HubSpot',
                        text: detalle,
                        showConfirmButton: false,
                        timer: 5000,
                    });
                })
                .finally(() => {
                    this.syncingEventoHubspot = false;
                });
        },
        validateEmail() {
            if (this.eventoid_seleccion.correo_notificaciones && !this.isEmailValid) {
                this.emailError = 'El correo electrónico no es válido.';
            } else {
                this.emailError = '';
            }
        },
        formatPhoneNumber() {
            // Elimina todo lo que no sea número
            let digits = this.eventoid_seleccion.telefono_notificaciones.replace(/\D/g, "");
            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }
            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }
            // Actualiza el input con el formato correcto
            this.eventoid_seleccion.telefono_notificaciones = "+" + digits;
        },
        validatePhoneNumber() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.eventoid_seleccion.telefono_notificaciones.length !== 12) {
                this.phoneerror = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        modificar_id(eventoseleccionada) {
            this.datoseventos.forEach(element => {
                if (element.nombre == eventoseleccionada) {
                    this.eventoid_seleccion = element.id;
                    //console.log(element.nombre);
                    this.habilitar_boton = true
                }
            });
        },
        toggleEdit() {
            this.originalevento = { ...this.eventoid_seleccion };
            if (this.editing) {
                if(this.validacion()){
                    this.isLoading=true;

                    const normalizarUsuario = (valor) => {
                        const item = Array.isArray(valor) ? valor[0] : valor;
                        if (!item) return null;
                        if (typeof item === 'object') return item;
                        if (typeof item === 'string') return { name: item };
                        return null;
                    };

                    const obtenerNombreUsuario = (valor) => {
                        const usuario = normalizarUsuario(valor);
                        return usuario ? (usuario.name || '') : '';
                    };

                    const coordinadorSeleccionado = Array.isArray(this.eventoid_seleccion.coordinador_evento)
                        ? this.eventoid_seleccion.coordinador_evento[0]
                        : this.eventoid_seleccion.coordinador_evento;
                    const propietarioSeleccionado = Array.isArray(this.eventoid_seleccion.propietario)
                        ? this.eventoid_seleccion.propietario[0]
                        : this.eventoid_seleccion.propietario;
                    const estadoSeleccionado = Array.isArray(this.eventoid_seleccion.estado_actividad)
                        ? this.eventoid_seleccion.estado_actividad[0]
                        : this.eventoid_seleccion.estado_actividad;
                    this.originalevento.nombre_difusion = this.eventoid_seleccion.nombre_difusion;
                    this.originalevento.fecha_inicio = this.eventoid_seleccion.fecha_inicio;
                    this.originalevento.fecha_termino = this.eventoid_seleccion.fecha_termino;
                    this.originalevento.tipo = this.eventoid_seleccion.tipo.codigo;
                    this.originalevento.tipo_codigo = this.eventoid_seleccion.tipo.codigo;
                    this.originalevento.subtipo = this.eventoid_seleccion.subtipo.codigo;
                    this.originalevento.subtipo_codigo = this.eventoid_seleccion.subtipo.codigo;
                    this.originalevento.curso_multi = JSON.stringify(this.normalizeCursosEvento(this.eventoid_seleccion.curso_multi));
                    this.originalevento.asistentes_por_curso = JSON.stringify(this.eventoid_seleccion.asistentes_por_curso || {});
                    this.originalevento.titulo_landing_inscripcion = this.eventoid_seleccion.titulo_landing_inscripcion;
                    this.originalevento.user_id = (normalizarUsuario(coordinadorSeleccionado) && normalizarUsuario(coordinadorSeleccionado).id)
                        ? normalizarUsuario(coordinadorSeleccionado).id
                        : null;
                    this.originalevento.coordinador_evento = (normalizarUsuario(coordinadorSeleccionado) && normalizarUsuario(coordinadorSeleccionado).rut)
                        ? normalizarUsuario(coordinadorSeleccionado).rut
                        : '';
                    this.originalevento.coordinador = obtenerNombreUsuario(coordinadorSeleccionado);
                    // Tomar el primer colegio del array múltiple (o el legacy colegio_datos)
                    const colegiosList = Array.isArray(this.colegiosEditSel) && this.colegiosEditSel.length
                        ? this.colegiosEditSel
                        : (this.eventoid_seleccion.colegios_datos || []);
                    const primerColegio = (colegiosList && colegiosList[0])
                        || this.eventoid_seleccion.colegio_datos
                        || null;
                    this.originalevento.rbd_colegio = primerColegio ? primerColegio.rbd : (this.eventoid_seleccion.rbd_colegio || 0);
                    this.originalevento.colegio = primerColegio ? primerColegio.nombre : (this.eventoid_seleccion.colegio || '');
                    this.originalevento.propietario_colegio = primerColegio ? (primerColegio.propietario || '') : '';
                    // Guardar array completo de colegios
                    this.originalevento.colegios_json = colegiosList.length > 1
                        ? JSON.stringify(colegiosList.map(c => ({ rbd: c.rbd, nombre: c.nombre })))
                        : null;
                    this.originalevento.propietario = obtenerNombreUsuario(propietarioSeleccionado);
                    this.originalevento.estado_actividad = estadoSeleccionado && estadoSeleccionado.nombre
                        ? estadoSeleccionado.nombre
                        : (typeof estadoSeleccionado === 'string' ? estadoSeleccionado : 'Vigente');
                    axios.post('/api/editar_evento',this.originalevento).then(res=>{
                        if(res.data.estado){
                            const colegioSeleccionado = colegiosList[0] || this.eventoid_seleccion.colegio_datos || null;
                            const colegioNombre = (colegioSeleccionado && colegioSeleccionado.nombre) || this.originalevento.colegio || '';
                            const colegioRbd = (colegioSeleccionado && colegioSeleccionado.rbd) || this.originalevento.rbd_colegio || null;
                            const colegioPropietario = (colegioSeleccionado && colegioSeleccionado.propietario) || this.originalevento.propietario_colegio || '';
                            this.eventoid_seleccion1 = res.data.evento;
                            this.$set(this.eventoid_seleccion1, 'colegio', this.eventoid_seleccion1.colegio || colegioNombre);
                            this.$set(this.eventoid_seleccion1, 'rbd_colegio', this.eventoid_seleccion1.rbd_colegio || colegioRbd);
                            this.$set(this.eventoid_seleccion1, 'propietario_colegio', this.eventoid_seleccion1.propietario_colegio || colegioPropietario);
                            this.$set(this.eventoid_seleccion1, 'colegio_datos', colegioSeleccionado || this.colegios.find((us) => us.rbd == this.eventoid_seleccion1.rbd_colegio) || null);

                            this.$set(this.eventoid_seleccion, 'colegio', this.eventoid_seleccion1.colegio);
                            this.$set(this.eventoid_seleccion, 'rbd_colegio', this.eventoid_seleccion1.rbd_colegio);
                            this.$set(this.eventoid_seleccion, 'propietario_colegio', this.eventoid_seleccion1.propietario_colegio);
                            this.$set(this.eventoid_seleccion, 'colegio_datos', this.eventoid_seleccion1.colegio_datos);
                            this.$set(this.eventoid_seleccion, 'colegios_datos', colegiosList);
                            this.colegiosEditSel = colegiosList;

                            const eventoEnLista = this.eventos.find(us => us.codigo == this.eventoid_seleccion1.codigo);
                            if (eventoEnLista) {
                                this.$set(eventoEnLista, 'colegio', this.eventoid_seleccion1.colegio);
                                this.$set(eventoEnLista, 'rbd_colegio', this.eventoid_seleccion1.rbd_colegio);
                                this.$set(eventoEnLista, 'propietario_colegio', this.eventoid_seleccion1.propietario_colegio);
                            }
                            this.eventoseleccionada = eventoEnLista || this.eventoid_seleccion1;
                            // Recalcular campos derivados que no vienen en la respuesta cruda
                            const tipoObj = this.tipos.find(t => t.codigo == this.eventoid_seleccion1.tipo_codigo);
                            const subtipoObj = this.subtipos.find(s => s.codigo == this.eventoid_seleccion1.subtipo_codigo);
                            this.$set(this.eventoid_seleccion1, 'tipo_nombre', tipoObj ? tipoObj.nombre : this.eventoid_seleccion1.tipo_codigo);
                            this.$set(this.eventoid_seleccion1, 'subtipo_nombre', subtipoObj ? subtipoObj.nombre : this.eventoid_seleccion1.subtipo_codigo);
                            const cursosNormalizados = this.normalizeCursosEvento(this.eventoid_seleccion1.curso_multi);
                            this.$set(this.eventoid_seleccion1, 'curso_multi', cursosNormalizados);
                            this.$set(this.eventoid_seleccion1, 'cursos', cursosNormalizados.join(';'));
                            this.$set(this.eventoid_seleccion, 'curso_multi', cursosNormalizados);
                            Swal.fire({
                                //position: "top-end",
                                icon: "success",
                                title: res.data.mensaje,
                                text: res.data.crm_warning || '',
                                showConfirmButton: false,
                                timer: 5000
                            });
                        }else{
                            Swal.fire({
                                //position: "top-end",
                                icon: "warning",
                                title: res.data.mensaje,
                                text: '',
                                showConfirmButton: false,
                                timer: 5000
                            });
                        }
                        this.isLoading=false
                    }).catch((err) => {
                        this.isLoading=false;
                        const msg = (err.response && err.response.data && err.response.data.mensaje)
                            ? err.response.data.mensaje
                            : 'Ocurrió un error al editar el evento.';
                        Swal.fire({
                            icon: "error",
                            title: "No se guardaron los cambios",
                            text: msg,
                            timer: 5000,
                            showConfirmButton: false
                        });
                    })
                }
            }
            this.editing = !this.editing;
        },
        enviarPreviewCorreoEvento(tipo = 'creacion_evento') {
            if (this.isSendingPreview) {
                return;
            }
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                return;
            }

            const opcionesColegios = (this.colegiosDetalleEvento || []).filter(col => col && col.rbd !== undefined && col.rbd !== null);
            if (opcionesColegios.length > 1) {
                const inputOptions = {};
                opcionesColegios.forEach((col) => {
                    inputOptions[String(col.rbd)] = `${col.rbd} - ${col.nombre}`;
                });

                Swal.fire({
                    title: 'Seleccionar colegio destinatario',
                    input: 'select',
                    inputOptions,
                    inputValue: this.previewCorreoColegioRbd ? String(this.previewCorreoColegioRbd) : String(opcionesColegios[0].rbd),
                    inputPlaceholder: 'Selecciona un colegio',
                    showCancelButton: true,
                    confirmButtonText: 'Continuar',
                    cancelButtonText: 'Cancelar',
                    inputValidator: (value) => !value ? 'Debes seleccionar un colegio.' : null,
                    didOpen: (popup) => {
                        const title = popup.querySelector('.swal2-title');
                        if (title) {
                            title.style.fontWeight = '400';
                        }
                        popup.querySelectorAll('.swal2-confirm, .swal2-cancel').forEach((btn) => {
                            btn.style.fontWeight = '400';
                        });
                    },
                }).then((result) => {
                    if (result.isConfirmed && result.value) {
                        this.previewCorreoColegioRbd = String(result.value);
                        this.abrirPreviewCorreoEvento(tipo, this.previewCorreoColegioRbd);
                    }
                });
                return;
            }

            const colegioRbd = opcionesColegios.length === 1 ? String(opcionesColegios[0].rbd) : null;
            this.previewCorreoColegioRbd = colegioRbd;
            this.abrirPreviewCorreoEvento(tipo, colegioRbd);
        },
        abrirPreviewCorreoEvento(tipo = 'creacion_evento', colegioRbd = null) {

            this.isSendingPreview = true;

            axios.post('/api/preview_correo_evento', {
                evento_id: this.eventoid_seleccion1.id,
                tipo,
                colegio_rbd: colegioRbd,
            }).then((response) => {
                if (response.data && response.data.preview_html) {
                    const popupId = 'ugm-preview-correo-iframe';
                    const para = Array.isArray(response.data.destinatarios_reales) ? response.data.destinatarios_reales : [];
                    const cc = Array.isArray(response.data.cc_reales) ? response.data.cc_reales : [];
                    const orientadorNombre = response.data.orientador_nombre || '';
                    const orientadorEmail = response.data.orientador_email || (para.length ? para.join(', ') : '');
                    const orientador = this.formatPreviewDestinatario(orientadorNombre, orientadorEmail);
                    const coordinador = response.data.coordinador_email || (cc.length ? cc.join(', ') : 'Sin correo');
                    const colegioNombre = response.data.colegio_nombre || 'Sin colegio';
                    const colegioRbdSel = response.data.colegio_rbd || '';
                    Swal.fire({
                        title: response.data.subject || 'Vista previa correo',
                        width: '85vw',
                        html: `
                            <div style="text-align:left; font-size:13px; background:#f8fafc; border:1px solid #e2e8f0; border-radius:8px; padding:10px 12px; margin-bottom:10px;">
                                <div><strong>Colegio seleccionado:</strong> ${colegioRbdSel ? `${colegioNombre} (${colegioRbdSel})` : colegioNombre}</div>
                                <div><strong>Para (Orientador):</strong> ${orientador}</div>
                                <div><strong>CC (Coordinador evento):</strong> ${coordinador}</div>
                            </div>
                            <iframe id="${popupId}" style="width:100%;height:70vh;border:1px solid #e2e8f0;border-radius:8px;background:#fff;"></iframe>
                        `,
                        showConfirmButton: true,
                        confirmButtonText: 'Enviar al usuario logueado',
                        showDenyButton: true,
                        denyButtonText: 'Enviar a destinatarios reales',
                        confirmButtonColor: '#252C5F',
                        denyButtonColor: '#252C5F',
                        showCancelButton: !!colegioRbdSel,
                        cancelButtonText: 'Cambiar correo orientador',
                        cancelButtonColor: '#252C5F',
                        showCloseButton: true,
                        didOpen: () => {
                            const iframe = document.getElementById(popupId);
                            if (iframe) {
                                iframe.srcdoc = response.data.preview_html;
                            }
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.enviarCorreoDesdePreview('usuario_logueado', tipo, response.data.colegio_rbd || colegioRbd);
                        } else if (result.isDenied) {
                            this.enviarCorreoDesdePreview('destinatarios_reales', tipo, response.data.colegio_rbd || colegioRbd);
                        } else if (result.dismiss === Swal.DismissReason.cancel && colegioRbdSel) {
                            this.abrirModalCambioOrientador({
                                tipo,
                                colegioRbd: colegioRbdSel,
                                colegioNombre,
                                orientadorNombre,
                                orientadorEmail,
                            });
                        }
                    });
                } else {
                    Swal.fire({
                        icon: response.data.estado ? 'success' : 'warning',
                        title: response.data.mensaje,
                        showConfirmButton: false,
                        timer: 4000,
                    });
                }
            }).catch(() => {
                Swal.fire({
                    icon: 'error',
                    title: 'No se pudo enviar la vista previa',
                    showConfirmButton: false,
                    timer: 4000,
                });
            }).finally(() => {
                this.isSendingPreview = false;
            });
        },
        formatPreviewDestinatario(nombre = '', correo = '') {
            const nombreTrim = String(nombre || '').trim();
            const correoTrim = String(correo || '').trim();

            if (nombreTrim && correoTrim) {
                return `${this.escapeHtml(nombreTrim)} &lt;${this.escapeHtml(correoTrim)}&gt;`;
            }

            if (correoTrim) {
                return this.escapeHtml(correoTrim);
            }

            if (nombreTrim) {
                return this.escapeHtml(nombreTrim);
            }

            return 'Sin correo';
        },
        escapeHtml(value = '') {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        },
        abrirModalCambioOrientador({ tipo = 'creacion_evento', colegioRbd = '', colegioNombre = '', orientadorNombre = '', orientadorEmail = '' } = {}) {
            Swal.fire({
                title: 'Cambiar correo orientador',
                html: `
                    <div style="text-align:left;">
                        <p style="margin-bottom:12px; color:#475569;"><strong>Colegio:</strong> ${this.escapeHtml(colegioNombre)}${colegioRbd ? ` (${this.escapeHtml(colegioRbd)})` : ''}</p>
                        <label for="swal-orientador-nombre" style="display:block;margin-bottom:6px;font-weight:600;">Nombre orientador</label>
                        <input id="swal-orientador-nombre" class="swal2-input" placeholder="Nombre orientador" value="${this.escapeHtml(orientadorNombre)}" style="margin:0 0 12px 0; width:100%;">
                        <label for="swal-orientador-correo" style="display:block;margin-bottom:6px;font-weight:600;">Correo orientador</label>
                        <input id="swal-orientador-correo" class="swal2-input" placeholder="orientador@colegio.cl" value="${this.escapeHtml(orientadorEmail)}" style="margin:0; width:100%;">
                    </div>
                `,
                focusConfirm: false,
                showCancelButton: true,
                confirmButtonText: 'Guardar y recargar preview',
                cancelButtonText: 'Cancelar',
                preConfirm: () => {
                    const nombre = document.getElementById('swal-orientador-nombre')?.value?.trim() || '';
                    const correo = document.getElementById('swal-orientador-correo')?.value?.trim() || '';
                    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                    if (!nombre) {
                        Swal.showValidationMessage('Debes ingresar el nombre del orientador.');
                        return false;
                    }

                    if (!correo) {
                        Swal.showValidationMessage('Debes ingresar el correo del orientador.');
                        return false;
                    }

                    if (!emailPattern.test(correo)) {
                        Swal.showValidationMessage('Debes ingresar un correo valido.');
                        return false;
                    }

                    return { nombre_orientador: nombre, correo_orientador: correo };
                }
            }).then((result) => {
                if (!result.isConfirmed || !result.value) {
                    return;
                }

                Swal.fire({
                    title: 'Guardando orientador...',
                    allowOutsideClick: false,
                    didOpen: () => Swal.showLoading(),
                });

                axios.post('/api/actualizar_orientador_preview_evento', {
                    colegio_rbd: colegioRbd,
                    nombre_orientador: result.value.nombre_orientador,
                    correo_orientador: result.value.correo_orientador,
                }).then((response) => {
                    const ok = !!(response.data && response.data.estado);
                    if (!ok) {
                        Swal.fire({
                            icon: 'warning',
                            title: response.data?.mensaje || 'No se pudo actualizar el orientador',
                            timer: 4000,
                            showConfirmButton: false,
                        });
                        return;
                    }

                    this.previewCorreoColegioRbd = colegioRbd ? String(colegioRbd) : null;
                    this.abrirPreviewCorreoEvento(tipo, colegioRbd);
                }).catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        title: error?.response?.data?.mensaje || 'No se pudo actualizar el orientador',
                        timer: 4000,
                        showConfirmButton: false,
                    });
                });
            });
        },
        enviarCorreoDesdePreview(modoEnvio = 'usuario_logueado', tipo = 'creacion_evento', colegioRbd = null) {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                return;
            }

            Swal.fire({
                title: 'Enviando correo...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            axios.post('/api/enviar_correo_preview_evento', {
                evento_id: this.eventoid_seleccion1.id,
                tipo,
                modo_envio: modoEnvio,
                colegio_rbd: colegioRbd,
            }).then((response) => {
                const ok = !!(response.data && response.data.estado);
                Swal.fire({
                    icon: ok ? 'success' : 'warning',
                    title: (response.data && response.data.mensaje) ? response.data.mensaje : 'No se pudo enviar el correo',
                    text: response.data && response.data.destinatarios
                        ? `Destinatarios: ${response.data.destinatarios.join(', ')}${response.data.colegio_nombre ? ` | Colegio: ${response.data.colegio_nombre}` : ''}`
                        : '',
                    timer: 5000,
                    showConfirmButton: false,
                });
            }).catch(() => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al enviar correo',
                    showConfirmButton: false,
                    timer: 4000,
                });
            });
        },
        cancelEdit() {
            // Restaurar los valores originales si se cancela la edición
            //this.sucursal = { ...this.originalSucursal };
            this.editing = false;
        },
        handleKeydown(event) {
            // Verifica si la tecla presionada es Enter o Enter del teclado numérico
            if (event.key == "Enter" || event.code == "Enter" || event.keyCode == 13) {
                event.preventDefault(); // Previene comportamientos predeterminados (como un submit en formularios)
                this.consultarEvento();
            }
        },
        labelEvento(evento) {
            const identificador = evento.codigo || `HS-${evento.hubspot_actividad_id || evento.id || ''}`;
            return `${identificador} - ${evento.nombre_difusion || ''}`;
        },
        normalizarEventoSinColegio(evento) {
            if (!evento || typeof evento !== 'object') {
                return evento;
            }

            const rbd = String(evento.rbd_colegio ?? '').trim();
            const colegio = String(evento.colegio ?? '').trim();
            if (rbd || colegio) {
                return evento;
            }

            this.$set(evento, 'rbd_colegio', 0);
            this.$set(evento, 'colegio', 'Sin colegio');
            return evento;
        },
        onSelectEvento(evento) {
            this.consultarEvento(evento);
        },
        onEnterSelectEvento() {
            this.consultarEvento();
        },
        select1(){
            this.eventoid_seleccion1 = this.eventoseleccionada;
            const tipoEncontrado = this.tipos.find((us) => us.codigo == this.eventoid_seleccion1.tipo_codigo);
            const subtipoEncontrado = this.subtipos.find((us) => us.codigo == this.eventoid_seleccion1.subtipo_codigo);
            this.eventoid_seleccion1.tipo_nombre = tipoEncontrado ? tipoEncontrado.nombre : (this.eventoid_seleccion1.tipo_codigo || this.eventoid_seleccion1.tipo || '');
            this.eventoid_seleccion1.subtipo_nombre = subtipoEncontrado ? subtipoEncontrado.nombre : (this.eventoid_seleccion1.subtipo_codigo || this.eventoid_seleccion1.subtipo || '');

            const cursoMultiRaw = this.eventoseleccionada && typeof this.eventoseleccionada === 'object'
                ? this.eventoseleccionada.curso_multi
                : null;
            const cursosNormalizados = this.normalizeCursosEvento(cursoMultiRaw);
            this.eventoid_seleccion1.cursos = cursosNormalizados.join(';');
            this.eventoid_seleccion1.curso_multi = cursosNormalizados;
            const estadoActual = this.eventoid_seleccion.estado_actividad === 'Activo' || !this.eventoid_seleccion.estado_actividad
                ? 'Vigente'
                : this.eventoid_seleccion.estado_actividad;
            this.eventoid_seleccion.estado_actividad = this.estados_eventos.find((us) => us.nombre == estadoActual)
                || { nombre: estadoActual, codigo: estadoActual.toLowerCase() };
        },
        select(){
            // Inicializar colegios_datos como array para multiselect múltiple
            if (this.eventoid_seleccion.colegios_json) {
                let lista = [];
                try { lista = JSON.parse(this.eventoid_seleccion.colegios_json); } catch(e) {}
                this.eventoid_seleccion.colegios_datos = lista.map(c =>
                    this.colegios.find(us => String(us.rbd) === String(c.rbd)) || { rbd: c.rbd, nombre: c.nombre }
                );
            } else {
                const single = this.colegios.find(us => us.rbd == this.eventoid_seleccion.rbd_colegio);
                this.eventoid_seleccion.colegios_datos = single ? [single] : [];
            }
            this.colegiosEditSel = [...this.eventoid_seleccion.colegios_datos];
            // legacy (para otros usos que usan colegio_datos)
            this.eventoid_seleccion.colegio_datos = this.eventoid_seleccion.colegios_datos[0] || null;
            const tipoActual = this.eventoid_seleccion.tipo;
            const tipoCodigo = (tipoActual && typeof tipoActual === 'object') ? tipoActual.codigo : tipoActual;
            this.eventoid_seleccion.tipo = this.tipos.find((us) => us.codigo == tipoCodigo) || (tipoActual || null);
            this.ver_subtipo();
            const subtipoActual = this.eventoid_seleccion.subtipo;
            const subtipoCodigo = (subtipoActual && typeof subtipoActual === 'object') ? subtipoActual.codigo : subtipoActual;
            this.eventoid_seleccion.subtipo = this.subtipos.find((us) => us.codigo == subtipoCodigo) || (subtipoActual || null);
            const coordinadorActual = this.eventoid_seleccion.coordinador_evento;
            const propietarioActual = this.eventoid_seleccion.propietario;
            this.eventoid_seleccion.coordinador_evento= this.usuarios.find((us) => us.name==coordinadorActual) || coordinadorActual || null;
            this.eventoid_seleccion.propietario= this.usuarios.find((us) => us.name==propietarioActual) || propietarioActual || null;
        },
        consultarEvento(eventoSeleccionado = null) {
            const eventoRaw = eventoSeleccionado || this.eventoseleccionada;
            const evento = Array.isArray(eventoRaw) ? eventoRaw[0] : eventoRaw;
            if (!evento || !evento.id) return;
            const requestToken = ++this.currentEventoRequestToken;

            this.normalizarEventoSinColegio(evento);
            if (this.eventoseleccionada && typeof this.eventoseleccionada === 'object') {
                this.normalizarEventoSinColegio(this.eventoseleccionada);
            }

            this.eventoid_seleccion = evento;
            this.eventoid_seleccion1 = evento;
            this.asistentesPage = 1;
            this.asistentesTotal = 0;
            this.asistentesResultadosTotal = 0;
            this.asistentesLastPage = 1;
            this.asistentesSearch = '';
            this.EventoNoExiste = false;
            this.isLoadingAsistentes = true;

            this.select1();
            this.select();

            this.eventoid_seleccion.curso_multi = this.normalizeCursosEvento(this.eventoid_seleccion.curso_multi);
            this.eventoid_seleccion1.curso_multi = this.normalizeCursosEvento(this.eventoid_seleccion1.curso_multi);
            // Parsear asistentes_por_curso de JSON string a objeto
            const apc = this.eventoid_seleccion.asistentes_por_curso;
            if (apc && typeof apc === 'string') {
                try { this.$set(this.eventoid_seleccion, 'asistentes_por_curso', JSON.parse(apc)); }
                catch (e) { this.$set(this.eventoid_seleccion, 'asistentes_por_curso', {}); }
            } else if (!apc || typeof apc !== 'object') {
                this.$set(this.eventoid_seleccion, 'asistentes_por_curso', {});
            }

            if (evento.id) {
                this.cargarPagosLaborantesEvento(evento.id, requestToken);
                this.cargarGastosEvento(evento.id, requestToken);
                this.cargarAsistentesEvento(evento.id, requestToken);
                this.cargarInsumosEvento(evento.id, requestToken);
                this.cargarEstadoImportacionAsistentes(evento.id);
            } else {
                this.pagosLaborantesEvento = [];
                this.$set(this.eventoid_seleccion1, 'gastos', []);
                this.$set(this.eventoid_seleccion1, 'asistentes', []);
                this.isLoadingAsistentes = false;
            }
        },
        abrirEventoPendienteDesdeStorage() {
            const query = new URLSearchParams(window.location.search || '');
            const eventoIdQuery = query.get('evento_id');
            const eventoCodigoQuery = query.get('evento_codigo');
            const eventoIdRaw = eventoIdQuery || localStorage.getItem('evento_id');
            const eventoCodigoRaw = eventoCodigoQuery || localStorage.getItem('evento_codigo');
            const eventoId = eventoIdRaw ? String(eventoIdRaw).trim() : '';
            const eventoCodigo = eventoCodigoRaw ? String(eventoCodigoRaw).trim() : '';

            if (!eventoId && !eventoCodigo) {
                return;
            }

            let encontrado = null;

            if (eventoId) {
                encontrado = this.eventos.find(ev => String(ev.id) === eventoId) || null;
            }

            if (!encontrado && eventoCodigo) {
                const normalizado = eventoCodigo.toLowerCase();
                encontrado = this.eventos.find(ev => String(ev.codigo || '').trim().toLowerCase() === normalizado) || null;
            }

            localStorage.removeItem('evento_id');
            localStorage.removeItem('evento_codigo');

            if (eventoIdQuery || eventoCodigoQuery) {
                query.delete('evento_id');
                query.delete('evento_codigo');
                const nextQuery = query.toString();
                const nextUrl = `${window.location.pathname}${nextQuery ? `?${nextQuery}` : ''}`;
                window.history.replaceState({}, document.title, nextUrl);
            }

            if (!encontrado) {
                return;
            }

            this.eventoseleccionada = encontrado;
            this.consultarEvento(encontrado);
        },
        cargarInsumosEvento(eventoId, requestToken = this.currentEventoRequestToken) {
            axios.get(`/api/get_insumos_evento/${eventoId}`).then(res => {
                if (requestToken !== this.currentEventoRequestToken) return;
                this.insumosEvento = (res.data && res.data.insumos) ? res.data.insumos : [];
            }).catch(() => {
                if (requestToken !== this.currentEventoRequestToken) return;
                this.insumosEvento = [];
            });
        },
        toggleInsumoForm() {
            if (!this.puedeGestionarInsumos) return;
            this.showInsumoForm = !this.showInsumoForm;
            if (!this.showInsumoForm) {
                this.insumo = { nombre: '', cantidad: '', unidad: '', observacion: '' };
            }
        },
        agregarInsumo() {
            if (!this.insumo.nombre || this.insumo.nombre.trim() === '') {
                Swal.fire({ icon: 'warning', title: 'Nombre requerido', text: 'Ingresa el nombre del insumo.', timer: 2500, showConfirmButton: false }); return;
            }
            if (this.insumo.cantidad === '' || isNaN(Number(this.insumo.cantidad)) || Number(this.insumo.cantidad) < 0) {
                Swal.fire({ icon: 'warning', title: 'Cantidad inválida', text: 'Ingresa una cantidad válida.', timer: 2500, showConfirmButton: false }); return;
            }
            this.isSavingInsumo = true;
            axios.post('/api/agregar_insumo', {
                evento_id: this.eventoid_seleccion1.id,
                nombre: this.insumo.nombre.trim(),
                cantidad: Number(this.insumo.cantidad),
                unidad: this.insumo.unidad || null,
                observacion: this.insumo.observacion || null,
            }).then(res => {
                if (res.data.estado) {
                    this.insumosEvento.push(res.data.insumo);
                    this.insumo = { nombre: '', cantidad: '', unidad: '', observacion: '' };
                    this.showInsumoForm = false;
                }
            }).catch(() => {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo agregar el insumo.', timer: 2500, showConfirmButton: false });
            }).finally(() => { this.isSavingInsumo = false; });
        },
        eliminarInsumo(id, idx) {
            Swal.fire({
                title: '¿Eliminar insumo?', icon: 'warning',
                showCancelButton: true, confirmButtonText: 'Sí, eliminar', cancelButtonText: 'Cancelar',
            }).then(result => {
                if (result.isConfirmed) {
                    axios.post('/api/eliminar_insumo', { id }).then(() => {
                        this.insumosEvento.splice(idx, 1);
                    });
                }
            });
        },
        cargarPagosLaborantesEvento(eventoId, requestToken = this.currentEventoRequestToken) {
            axios.get(`/api/pagos_evento/${eventoId}`).then(res => {
                if (requestToken !== this.currentEventoRequestToken) return;
                this.pagosLaborantesEvento = (res.data && res.data.pagos_laborantes) ? res.data.pagos_laborantes : [];
            }).catch(err => {
                if (requestToken !== this.currentEventoRequestToken) return;
                console.error('Error al cargar pagos del evento', err);
                this.pagosLaborantesEvento = [];
            });
        },
        cargarGastosEvento(eventoId, requestToken = this.currentEventoRequestToken) {
            axios.get(`/api/get_gastos_evento/${eventoId}`).then(res => {
                if (requestToken !== this.currentEventoRequestToken) return;
                const gastos = (res.data && Array.isArray(res.data.gastos)) ? res.data.gastos : [];
                if (!this.eventoid_seleccion1 || typeof this.eventoid_seleccion1 !== 'object') {
                    this.eventoid_seleccion1 = {};
                }
                this.$set(this.eventoid_seleccion1, 'gastos', gastos);
            }).catch(err => {
                if (requestToken !== this.currentEventoRequestToken) return;
                console.error('Error al cargar gastos del evento', err);
                if (!this.eventoid_seleccion1 || typeof this.eventoid_seleccion1 !== 'object') {
                    this.eventoid_seleccion1 = {};
                }
                this.$set(this.eventoid_seleccion1, 'gastos', []);
            });
        },
        cargarAsistentesEvento(eventoId, requestToken = this.currentEventoRequestToken, page = this.asistentesPage) {
            const eventoIdStr = String(eventoId || '');
            const eventoSigueSeleccionado = () => {
                const seleccionadoId = String(
                    (this.eventoid_seleccion1 && this.eventoid_seleccion1.id)
                    || (this.eventoid_seleccion && this.eventoid_seleccion.id)
                    || ''
                );

                return eventoIdStr !== '' && seleccionadoId === eventoIdStr;
            };

            this.isLoadingAsistentes = true;
            axios.get(`/api/get_asistentes_evento/${eventoId}`, {
                params: { page, per_page: this.asistentesPerPage, search: this.asistentesSearch }
            }).then(res => {
                if (requestToken !== this.currentEventoRequestToken && !eventoSigueSeleccionado()) return;
                const asistentes = (res.data && Array.isArray(res.data.asistentes)) ? res.data.asistentes : [];
                if (!this.eventoid_seleccion1 || typeof this.eventoid_seleccion1 !== 'object') {
                    this.eventoid_seleccion1 = {};
                }
                this.$set(this.eventoid_seleccion1, 'asistentes', asistentes);
                const pagination = (res.data && res.data.pagination) || {};
                this.asistentesResultadosTotal = Number(Object.prototype.hasOwnProperty.call(pagination, 'total') ? pagination.total : asistentes.length);
                this.asistentesTotal = Number(Object.prototype.hasOwnProperty.call(pagination, 'total_unfiltered') ? pagination.total_unfiltered : this.asistentesResultadosTotal);
                this.asistentesPage = Number(pagination.current_page || page);
                this.asistentesLastPage = Number(pagination.last_page || 1);
            }).catch(err => {
                if (requestToken !== this.currentEventoRequestToken && !eventoSigueSeleccionado()) return;
                console.error('Error al cargar asistentes del evento', err);
                if (!this.eventoid_seleccion1 || typeof this.eventoid_seleccion1 !== 'object') {
                    this.eventoid_seleccion1 = {};
                }
                this.$set(this.eventoid_seleccion1, 'asistentes', []);
                if (page === 1) this.asistentesResultadosTotal = 0;
            }).finally(() => {
                if (requestToken !== this.currentEventoRequestToken && !eventoSigueSeleccionado()) return;
                this.isLoadingAsistentes = false;
            });
        },
        cargarPaginaAsistentes(page) {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) return;
            this.cargarAsistentesEvento(this.eventoid_seleccion1.id, this.currentEventoRequestToken, page);
        },
        buscarAsistentes() {
            clearTimeout(this.asistentesSearchTimer);
            this.asistentesSearchTimer = setTimeout(() => {
                this.asistentesPage = 1;
                this.cargarPaginaAsistentes(1);
            }, 350);
        },
        formatCLP(valor) {
            const numero = parseInt((valor || 0).toString().replace(/[^0-9]/g, ''), 10) || 0;
            return numero.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' });
        },
        ver_subtipo(){
            const tipo = this.eventoid_seleccion && this.eventoid_seleccion.tipo;
            if (!tipo || typeof tipo !== 'object' || !tipo.id) {
                this.subtiposfilter = [];
                return;
            }
            this.subtiposfilter = this.subtipos.filter((subtipo) => subtipo.tipo_id==tipo.id);
        },
        labelselect_tipo ({ nombre }) {
            return `${nombre}`
        },
        ver_colegio(rbd){
            localStorage.setItem('rbd_colegio',rbd);
            window.location.href = "/web/configuracion/colegios";
        },
        buscar_colegio(){
            if (this.colegiosDetalleEvento.length > 1) {
                const inputOptions = {};
                this.colegiosDetalleEvento.forEach((col) => {
                    inputOptions[String(col.rbd)] = `${col.rbd} - ${col.nombre}`;
                });

                Swal.fire({
                    title: 'Seleccionar colegio',
                    input: 'select',
                    inputOptions,
                    inputValue: String(this.colegiosDetalleEvento[0].rbd),
                    inputPlaceholder: 'Selecciona un colegio',
                    showCancelButton: true,
                    confirmButtonText: 'Ver colegio',
                    cancelButtonText: 'Cancelar',
                    inputValidator: (value) => !value ? 'Debes seleccionar un colegio.' : null,
                    didOpen: (popup) => {
                        const title = popup.querySelector('.swal2-title');
                        if (title) {
                            title.style.fontWeight = '400';
                        }
                        popup.querySelectorAll('.swal2-confirm, .swal2-cancel').forEach((btn) => {
                            btn.style.fontWeight = '400';
                        });
                    },
                }).then((result) => {
                    if (result.isConfirmed && result.value) {
                        this.ver_colegio(result.value);
                    }
                });
                return;
            }

            const rbd = this.eventoTieneColegioFallback ? 0 : this.eventoid_seleccion.rbd_colegio;
            localStorage.setItem("rbd_colegio", rbd);
            window.location.href = "/web/configuracion/colegios";
        },
        msgval(campo) {
            Swal.fire({
                icon: 'error',
                title: 'Campo Obligatorio',
                text: `Por favor, completa el campo "${campo}".`,
                confirmButtonText: 'Aceptar'
            });
        },
        toggleCursoEdit(curso) {
            const apc = this.eventoid_seleccion.asistentes_por_curso || {};
            if (apc.hasOwnProperty(curso)) {
                this.$delete(this.eventoid_seleccion.asistentes_por_curso, curso);
                const cursos = Array.isArray(this.eventoid_seleccion.curso_multi)
                    ? this.eventoid_seleccion.curso_multi.filter(c => c !== curso)
                    : [];
                this.$set(this.eventoid_seleccion, 'curso_multi', cursos);
            } else {
                this.$set(this.eventoid_seleccion.asistentes_por_curso, curso, null);
                const cursos = Array.isArray(this.eventoid_seleccion.curso_multi)
                    ? [...this.eventoid_seleccion.curso_multi, curso]
                    : [curso];
                this.$set(this.eventoid_seleccion, 'curso_multi', cursos);
            }
        },
        isCursoSelectedEdit(curso) {
            const apc = this.eventoid_seleccion.asistentes_por_curso;
            return apc && apc.hasOwnProperty(curso);
        },
        validacion() {
            const campos = {
                nombre_difusion: 'Actividad',
                codigo: 'Código',
                fecha_inicio: 'Fecha Inicio',
                fecha_termino: 'Fecha Término',
                tipo: 'Tipo',
                subtipo: 'Subtipo',
                curso_multi: 'Curso',
                coordinador_evento: 'Coordinador evento',
            };
            for (let campo in campos) {
                if (!this.eventoid_seleccion[campo]) {
                    this.msgval(campos[campo]);
                    return false;
                }
            }
            return true;//this.crear_evento();
        },
        async copiarLink(link) {
            try {
                await navigator.clipboard.writeText(link);
                this.copiado = true;
                this.$toasted.success('Link Copiado');
                setTimeout(() => (this.copiado = false), 2000);
            } catch (err) {
                this.$toasted.error("Error al copiar: ", err);
            }
        },
        labelselect_tipo ({ nombre }) {
            return `${nombre}`
        },
        labelselect_usuarios ({ name }) {
            return `${name}`
        },
        labelselect_colegio ({ nombre , rbd}) {
            return `${rbd}-${nombre}`
        },
        eliminar(id){
            Swal.fire({
                title: '¿Estas seguro que deseas eliminar el evento?',
                text: "Esto no se podrá revertir",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, estoy seguro',
                cancelButtonText: 'Cancelar',
                }).then((result) => {
                if (result.isConfirmed) {
                    let formData = new FormData();
                    formData.append('id', id);
                    axios.post('/api/eliminar_evento',formData).then(res=>{
                        if (res.data.estado) {
                            Swal.fire({
                                title: 'Eliminado',
                                text: "Evento eliminado",
                                icon: 'success',
                                confirmButtonText: 'Aceptar',
                            })
                        }else{
                            Swal.fire({
                                title: 'No se puede eliminar',
                                text: res.data.mensaje,
                                icon: 'warning',
                                confirmButtonText: 'Aceptar',
                            })
                        }

                    });
                }
            });
        },
        cambio_estado(es){
            let formData = new FormData();
            formData.append('id', this.eventoid_seleccion1.id);
            formData.append('estado', es);
            axios.post('/api/cambio_estado',formData).then(res=>{
                if (res.data.estado) {
                    Swal.fire({
                        icon: "success",
                        title: "Cambio de estado exitoso",
                        text: es,
                        timer: 5000,
                        showConfirmButton: false
                    });
                    this.eventoseleccionada = this.eventos.find(us => us.codigo == this.eventoid_seleccion1.codigo) || null;
                    this.consultarEvento(this.eventoseleccionada);
                }else{
                    Swal.fire({
                        icon: "error",
                        title: "No se cambió el estado",
                        text: '',
                        timer: 3000,
                        showConfirmButton: false
                    });
                }
            });
        },
        correo_agradecimiento(){
            axios.get('/api/envio_agradecimiento').then(res=>{
                if (res.data.estado) {
                    Swal.fire({
                        icon: "success",
                        title: "Envio de correo exitoso",
                        text: '',
                        timer: 5000,
                        showConfirmButton: false
                    });
                }
            });
        },
        toggleUploadAsistentes() {
            this.showUploadAsistentes = !this.showUploadAsistentes;
            if (!this.showUploadAsistentes) this.resetAsistentesFileInput();
        },
        resumenEliminacionAsistentes(data) {
            const detalles = [];
            if (Number(data.hubspot_eliminados || 0) > 0) {
                detalles.push(`HubSpot: ${data.hubspot_eliminados} contactos eliminados.`);
            }
            if (Number(data.hubspot_restaurados || 0) > 0) {
                detalles.push(`HubSpot: ${data.hubspot_restaurados} propiedades restauradas.`);
            }
            if (Number(data.hubspot_desasociados || 0) > 0) {
                detalles.push(`${data.hubspot_desasociados} contactos desasociados del evento.`);
            }
            if (Number(data.hubspot_contactos_desasociados_de_colegios || 0) > 0) {
                detalles.push(`${data.hubspot_contactos_desasociados_de_colegios} contactos desasociados de colegios.`);
            }
            if (Number(data.hubspot_colegios_desasociados || 0) > 0) {
                detalles.push(`${data.hubspot_colegios_desasociados} asociaciones de colegios con la actividad deshechas.`);
            }
            if (Number(data.hubspot_contactos_sin_snapshot || 0) > 0) {
                detalles.push(`${data.hubspot_contactos_sin_snapshot} contactos existentes no pudieron restaurarse porque la carga no tenía snapshot.`);
            }
            if (Number(data.hubspot_propiedades_omitidas_por_cambios || 0) > 0) {
                detalles.push(`${data.hubspot_propiedades_omitidas_por_cambios} propiedades no se restauraron porque cambiaron después de la carga.`);
            }
            if (Number(data.hubspot_no_eliminados_por_otras_asociaciones || 0) > 0) {
                detalles.push(`${data.hubspot_no_eliminados_por_otras_asociaciones} contactos creados se conservaron porque tienen otras asociaciones.`);
            }
            if (Number(data.hubspot_no_eliminados_por_verificacion || 0) > 0) {
                detalles.push(`${data.hubspot_no_eliminados_por_verificacion} contactos creados no se eliminaron porque no fue posible verificar sus asociaciones.`);
            }
            if (Number(data.hubspot_asociaciones_sin_estado || 0) > 0) {
                detalles.push(`${data.hubspot_asociaciones_sin_estado} asociaciones quedaron sin estado verificable y requieren reintento.`);
            }
            if (Number(data.hubspot_errores || 0) > 0) {
                detalles.push(`HubSpot: ${data.hubspot_errores} errores.`);
            }
            if (Number(data.hubspot_colegios_errores || 0) > 0) {
                detalles.push(`HubSpot: ${data.hubspot_colegios_errores} asociaciones de colegios con error.`);
            }

            return detalles.join(' ');
        },
        eliminarTodosAsistentesEvento() {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                return;
            }

            Swal.fire({
                icon: 'warning',
                title: 'Eliminar asistentes del evento',
                text: 'Se borrarán los asistentes locales. Si estos asistentes provienen de una digitalización, también se eliminará la digitalización asociada. Los contactos se desasociarán del evento y del colegio; los creados por esta carga se eliminarán y los existentes se restaurarán cuando haya información de reversión.',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (!result.isConfirmed) {
                    return;
                }

                this.isDeletingAsistentes = true;
                axios.post('/api/eliminar_asistentes_evento', { id: this.eventoid_seleccion1.id })
                    .then((res) => {
                        if (!res.data.estado) {
                            Swal.fire({
                                icon: 'warning',
                                title: res.data.mensaje || 'No se pudieron eliminar los asistentes.',
                                text: this.resumenEliminacionAsistentes(res.data),
                                timer: 6000,
                                showConfirmButton: false,
                            });
                            return;
                        }

                        this.$set(this.eventoid_seleccion1, 'asistentes', []);
                        if (this.eventoid_seleccion && typeof this.eventoid_seleccion === 'object') {
                            this.$set(this.eventoid_seleccion, 'asistentes', []);
                        }
                        this.showUploadAsistentes = false;
                        this.resetAsistentesFileInput();

                        Swal.fire({
                            icon: 'success',
                            title: res.data.mensaje || 'Asistentes eliminados.',
                            text: this.resumenEliminacionAsistentes(res.data),
                            timer: 5000,
                            showConfirmButton: false,
                        });
                    })
                    .catch(() => {
                        Swal.fire({ icon: 'error', title: 'No se pudieron eliminar los asistentes.', timer: 4000, showConfirmButton: false });
                    })
                    .finally(() => {
                        this.isDeletingAsistentes = false;
                    });
            });
        },
        resetAsistentesFileInput() {
            this.selectedAsistentesFile = null;
            if (this.$refs.asistentesFileInput && this.$refs.asistentesFileInput.reset) {
                this.$refs.asistentesFileInput.reset();
            }
            this.asistentesFileKey += 1;
        },
        obtenerPreferenciasAsistente(asistente) {
            const primerValor = (campos) => {
                for (const campo of campos) {
                    const valor = asistente && asistente[campo] !== null && asistente[campo] !== undefined
                        ? String(asistente[campo]).trim()
                        : '';
                    if (valor !== '') return valor;
                }
                return '';
            };
            const tieneCampo = (campo) => asistente
                && Object.prototype.hasOwnProperty.call(asistente, campo);
            const valorCanonico = (campo, aliases) => tieneCampo(campo)
                ? String(asistente[campo] === null || asistente[campo] === undefined ? '' : asistente[campo]).trim()
                : primerValor(aliases);
            const fuente = String((asistente && asistente.fuente) || '').toLowerCase();
            const aliasesExtra1 = ['preferencia_1_otra'];
            if (fuente === 'digitalizador' || fuente === '' || !tieneCampo('preferencia_extra')) {
                aliasesExtra1.push('preferencia_3_otra');
            }

            return {
                preferencia_1: primerValor(['preferencia_1']),
                preferencia_2: primerValor(['preferencia_2']),
                preferencia_3: primerValor(['preferencia_3']),
                preferencia_extra: valorCanonico('preferencia_extra', aliasesExtra1),
                preferencia_extra_2: valorCanonico('preferencia_extra_2', ['preferencia_2_otra']),
            };
        },
        mostrarPreferenciaAsistente(asistente, campo) {
            return this.obtenerPreferenciasAsistente(asistente)[campo] || '-';
        },
        onFileChange(event) {
            const file = event.target.files && event.target.files[0];
            this.selectedAsistentesFile = file || null;
        },
        descargarPlantillaAsistentes() {
            const asistentes = (this.eventoid_seleccion1 && Array.isArray(this.eventoid_seleccion1.asistentes))
                ? this.eventoid_seleccion1.asistentes
                : [];

            if (!asistentes.length) {
                Swal.fire({
                    icon: 'warning',
                    title: 'No hay asistentes para descargar',
                    timer: 2500,
                    showConfirmButton: false,
                });
                return;
            }

            const filas = [
                ['rut', 'nombres', 'apellidos', 'otro', 'curso', 'colegio', 'celular', 'email', 'fecha_nacimiento', 'preferencia_1', 'preferencia_2', 'preferencia_3', 'preferencia_extra', 'preferencia_extra_2'],
                ...asistentes.map((a) => {
                    const preferencias = this.obtenerPreferenciasAsistente(a);
                    return [
                        a.rut || '',
                        a.nombres || a.nombre || '',
                        a.apellido_paterno || '',
                        a.apellido_materno || '',
                        a.curso || '',
                        a.establecimiento || '',
                        a.celular || '',
                        a.email || '',
                        a.fecha_nacimiento || '',
                        preferencias.preferencia_1,
                        preferencias.preferencia_2,
                        preferencias.preferencia_3,
                        preferencias.preferencia_extra,
                        preferencias.preferencia_extra_2,
                    ];
                }),
            ];

            const csv = filas
                .map(fila => fila.map(valor => `"${String(valor).replace(/"/g, '""')}"`).join(';'))
                .join('\n');

            const baseName = (this.eventoid_seleccion1 && (this.eventoid_seleccion1.codigo || this.eventoid_seleccion1.nombre_difusion || 'evento')) || 'evento';
            const safeName = String(baseName)
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-zA-Z0-9_-]+/g, '_')
                .replace(/^_+|_+$/g, '')
                .slice(0, 80) || 'evento';

            const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `asistentes_${safeName}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        },
        consumirProgresoUploadAsistentes(texto, vaciarBuffer = false) {
            if (typeof texto !== 'string') return;

            const textoNuevo = texto.length >= this.uploadStreamResponseLength
                ? texto.slice(this.uploadStreamResponseLength)
                : texto;
            if (texto.length < this.uploadStreamResponseLength) {
                this.uploadStreamBuffer = '';
            }

            this.uploadStreamBuffer += textoNuevo;
            this.uploadStreamResponseLength = texto.length;

            const lineas = this.uploadStreamBuffer.split(/\r?\n/);
            const resto = lineas.pop() || '';
            this.uploadStreamBuffer = vaciarBuffer ? '' : resto;

            if (vaciarBuffer && resto) {
                lineas.push(resto);
                this.uploadStreamBuffer = '';
            }

            lineas.forEach((linea) => {
                const contenido = String(linea || '').trim();
                if (!contenido || contenido[0] !== '{') return;

                try {
                    const evento = JSON.parse(contenido);
                    if (evento.type === 'progress') {
                        this.uploadProgress = Object.assign({}, this.uploadProgress || {}, evento);
                    } else if (evento.type === 'complete') {
                        this.uploadStreamResult = evento.resultado || {};
                    } else if (Object.prototype.hasOwnProperty.call(evento, 'estado')) {
                        // Compatibilidad con una respuesta JSON no transmitida en streaming.
                        this.uploadStreamResult = evento;
                    }
                } catch (e) {
                    // Los fragmentos incompletos se conservan para el siguiente evento.
                }
            });
        },
        uploadAsistentes() {
            if (!this.selectedAsistentesFile) {
                this.$toasted && this.$toasted.error ? this.$toasted.error('Seleccione un archivo') : Swal.fire('Seleccione un archivo');
                return;
            }
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                Swal.fire('Evento no seleccionado');
                return;
            }
            const formData = new FormData();
            formData.append('id', this.eventoid_seleccion1.id);
            formData.append('file', this.selectedAsistentesFile);
            this.isLoading = true;

            axios.post('/api/upload_asistentes', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
                .then(res => {
                    const resultado = res.data || {};
                    if (resultado.estado) {
                        this.importacionAsistentes = resultado.importacion || null;
                        Swal.fire({
                            icon: 'success',
                            title: resultado.mensaje || 'Importación iniciada',
                            timer: 3000,
                            showConfirmButton: false
                        });
                        this.showUploadAsistentes = false;
                        this.resetAsistentesFileInput();
                        this.iniciarSeguimientoImportacionAsistentes();
                    } else {
                        Swal.fire({ icon: 'error', title: resultado.mensaje || 'Error al cargar asistentes', timer: 3000, showConfirmButton: false });
                    }
                })
                .catch(err => {
                    console.error(err);
                    const mensaje = this.obtenerMensajeErrorAxios(err, 'Error al subir archivo');
                    Swal.fire({ icon: 'error', title: mensaje, timer: 3500, showConfirmButton: false });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        cargarEstadoImportacionAsistentes(eventoId, notificar = false) {
            if (!eventoId) return Promise.resolve();

            return axios.get(`/api/importacion_asistentes/${eventoId}`).then((res) => {
                if (!this.eventoid_seleccion1 || Number(this.eventoid_seleccion1.id) !== Number(eventoId)) return;

                this.importacionAsistentes = res.data.importacion || null;
                if (this.importacionAsistentesActiva) {
                    this.iniciarSeguimientoImportacionAsistentes();
                    return;
                }

                this.detenerSeguimientoImportacionAsistentes();
                if (this.importacionAsistentes && this.importacionAsistentes.estado === 'completed') {
                    this.cargarAsistentesEvento(eventoId, this.currentEventoRequestToken);
                    if (notificar) {
                        Swal.fire({ icon: 'success', title: this.importacionAsistentes.mensaje || 'Importación completada', timer: 5000, showConfirmButton: false });
                    }
                } else if (notificar && this.importacionAsistentes && this.importacionAsistentes.estado === 'failed') {
                    Swal.fire({ icon: 'error', title: this.importacionAsistentes.mensaje || 'La importación falló', text: this.importacionAsistentes.error || '', timer: 6000, showConfirmButton: false });
                }
            }).catch(() => {
                this.detenerSeguimientoImportacionAsistentes();
            });
        },
        iniciarSeguimientoImportacionAsistentes() {
            this.detenerSeguimientoImportacionAsistentes();
            if (!this.importacionAsistentesActiva || !this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) return;

            const eventoId = this.eventoid_seleccion1.id;
            this.importacionAsistentesTimer = window.setTimeout(() => {
                this.importacionAsistentesTimer = null;
                this.cargarEstadoImportacionAsistentes(eventoId, true);
            }, 3000);
        },
        detenerSeguimientoImportacionAsistentes() {
            if (this.importacionAsistentesTimer) {
                window.clearTimeout(this.importacionAsistentesTimer);
                this.importacionAsistentesTimer = null;
            }
        },
        toggleGastoForm() {
            if (!this.puedeGestionarDetalleEvento) return;
            this.showGastoForm = !this.showGastoForm;
            if (!this.showGastoForm) {
                this.resetGastoForm();
            }
        },
        resetGastoForm() {
            this.gasto = { tipo: null, monto: '$0', imagen: null };
            this.tipoArchivo = '';
            this.imagenminiatura = '';
        },
        format_Valor() {
            this.gasto.monto = this.format_Valor_variable(this.gasto.monto);
            this.valor_editar.monto = this.format_Valor_variable(this.valor_editar.monto);
        },
        format_Valor_variable(val){
            return val? parseInt(val.toString().replace(/[^0-9]/g, ''), 10)? parseInt(val.toString().replace(/[^0-9]/g, ''), 10).toLocaleString("es-CL", { style: "currency", currency: "CLP" }): '$0': '$0';
        },
        obtenerArchivoDesdeEntrada(payload) {
            if (!payload) return null;
            if (payload.target && payload.target.files) {
                return payload.target.files[0] || null;
            }
            if (typeof payload.length === 'number' && payload.length > 0 && payload[0]) {
                return payload[0] || null;
            }
            if (Array.isArray(payload)) {
                return payload[0] || null;
            }
            return payload instanceof File ? payload : null;
        },
        actualizarPreviewDocumento(file) {
            this.imagenminiatura = '';
            this.tipoArchivo = '';
            if (!file) return;

            const nombre = (file.name || '').toLowerCase();
            const extension = nombre.includes('.') ? nombre.split('.').pop() : '';

            if (file.type === 'application/pdf' || extension === 'pdf') {
                this.tipoArchivo = 'pdf';
                this.imagenminiatura = URL.createObjectURL(file);
                return;
            }

            const extensionesImagen = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif'];
            if ((file.type && file.type.startsWith('image/')) || extensionesImagen.includes(extension)) {
                this.tipoArchivo = 'imagen';
                this.imagenminiatura = URL.createObjectURL(file);
            }
        },
        obtenerImagen(eventoOArchivo) {
            const file = this.obtenerArchivoDesdeEntrada(eventoOArchivo);
            this.gasto.imagen = file || null;
            this.actualizarPreviewDocumento(file);
        },
        obtenerImagenEditar(eventoOArchivo) {
            const file = this.obtenerArchivoDesdeEntrada(eventoOArchivo);
            this.valor_editar.imagen = file || null;
            this.actualizarPreviewDocumento(file);
        },
        validaciones() {
            if (!this.gasto.tipo) {
                this.msgval('Tipo de gasto');
                return;
            }
            const montoLimpio = String(this.gasto.monto || '').replace(/[^0-9]/g, '');
            if (!montoLimpio || Number(montoLimpio) <= 0) {
                this.msgval('Monto del Gasto');
                return;
            }
            if (!this.gasto.imagen) {
                this.msgval('Documento Asociado');
                return;
            }
            if (this.gasto.imagen && this.gasto.imagen.size > (2 * 1024 * 1024)) {
                this.msg('error', 'El comprobante no puede superar 2 MB');
                return;
            }
            this.guardar();
        },
        guardar(){
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                this.msg('error','Evento no seleccionado');
                return;
            }
            let formData = new FormData();
            const montoLimpio = String(this.gasto.monto || '').replace(/[^0-9]/g, '');
            formData.append('evento_id', this.eventoid_seleccion1.id);
            formData.append('fecha', this.eventoid_seleccion1.fecha_inicio || '');
            formData.append('tipo', this.gasto.tipo);
            formData.append('monto', montoLimpio);
            formData.append('imagen', this.gasto.imagen);
            formData.append('coordinador_id', this.eventoid_seleccion1.user_id || '');
            axios.post('/api/agregar_gastos',formData).then(res=>{
                if(res.data.estado){
                    this.resetGastoForm();
                    this.cargarGastosEvento(this.eventoid_seleccion1.id);
                    this.msg('success','Gasto agregado correctamente');
                }else{
                    this.msg('error', res.data.mensaje || 'Gasto No agregado');
                }
            }).catch((error) => {
                const mensaje = this.obtenerMensajeErrorAxios(error, 'Error al guardar gasto');
                this.msg('error', mensaje);
            });
        },
        ver_comprobante(item){
            if (item.imagen_url) {
                const extension = item.imagen_url.split('.').pop().toLowerCase();
                if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
                    this.direccion = item.imagen_url;
                    this.extension = '';
                } else if (extension === 'pdf') {
                    this.direccion = item.imagen_url;
                    this.extension = 'pdf';
                }
            }
            this.$refs['modal-imagen'].show();
        },
        modal_editar(gasto) {
            this.valor_editar = {
                ...gasto,
                tipo: gasto.tipo_gasto,
                monto: this.format_Valor_variable(gasto.monto),
                imagen: null,
            };
            this.direccion = gasto.imagen_url || '';
            const ext = (this.direccion.split('.').pop() || '').toLowerCase();
            this.extension = ext === 'pdf' ? 'pdf' : 'img';
            this.cambiar = false;
            this.$refs['modal-editar'].show();
        },
        btn_cambiar() {
            this.cambiar = !this.cambiar;
            if (!this.cambiar) {
                this.valor_editar.imagen = null;
                this.tipoArchivo = '';
                this.imagenminiatura = '';
            }
        },
        editar() {
            if (!this.valor_editar || !this.valor_editar.id) return;

            if (this.cambiar && this.valor_editar.imagen && this.valor_editar.imagen.size > (2 * 1024 * 1024)) {
                this.msg('error', 'El comprobante no puede superar 2 MB', '');
                return;
            }

            const formData = new FormData();
            formData.append('id', this.valor_editar.id);
            formData.append('tipo', this.valor_editar.tipo || '');
            formData.append('monto', String(this.valor_editar.monto || '').replace(/[^0-9]/g, ''));
            if (this.cambiar && this.valor_editar.imagen) {
                formData.append('imagen', this.valor_editar.imagen);
            }

            axios.post('/api/editar_gastos', formData).then(res => {
                if (res.data && res.data.estado) {
                    this.cargarGastosEvento(this.eventoid_seleccion1.id);
                    this.msg('success', 'Gasto actualizado', '');
                } else {
                    this.msg('error', 'No se pudo actualizar', '');
                }
            }).catch((error) => {
                const mensaje = this.obtenerMensajeErrorAxios(error, 'No se pudo actualizar');
                this.msg('error', mensaje, '');
            });
        },
        eliminar_gasto(gasto) {
            if (!gasto || !gasto.id) return;
            Swal.fire({
                title: '¿Eliminar gasto?',
                text: 'Esta acción no se puede deshacer',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (!result.isConfirmed) return;

                const formData = new FormData();
                formData.append('gasto_id', gasto.id);
                axios.post('/api/eliminar_gastos', formData).then(res => {
                    if (res.data && res.data.estado) {
                        this.cargarGastosEvento(this.eventoid_seleccion1.id);
                        this.msg('success', 'Gasto eliminado', '');
                    } else {
                        this.msg('error', 'No se pudo eliminar', '');
                    }
                }).catch(() => {
                    this.msg('error', 'No se pudo eliminar', '');
                });
            });
        },
        msg(tipo,titulo,frase){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                text: frase,
                showConfirmButton: false,
                timer: 5000
            });
        },
        obtenerMensajeErrorAxios(error, mensajePorDefecto = 'Ha ocurrido un error') {
            const data = error && error.response ? error.response.data : null;
            if (data && data.errors && typeof data.errors === 'object') {
                const primerCampo = Object.keys(data.errors)[0];
                if (primerCampo && Array.isArray(data.errors[primerCampo]) && data.errors[primerCampo].length) {
                    return data.errors[primerCampo][0];
                }
            }
            if (data && data.mensaje) return data.mensaje;
            if (data && data.message) return data.message;
            return mensajePorDefecto;
        },
    },
    mounted(){
        // Las cargas iniciales ahora se hacen en created() con Promise.all
    },
    beforeDestroy() {
        this.detenerSeguimientoImportacionAsistentes();
        clearTimeout(this.asistentesSearchTimer);
    },
    created(){
        this.isLoading=true;
        Promise.all([
            axios.get('/api/get_eventos'),
            axios.get('/api/get_tipos'),
            axios.get('/api/get_colegios'),
            axios.get('/api/get_usuarios'),
        ]).then(([resEventos, resTipos, resColegios, resUsuarios]) => {
            // Eventos
            this.estados_eventos = resEventos.data.estados_eventos;
            const eventosSinSimulador = (resEventos.data.eventos || []).filter(ev => !this.esInteraccionSimulador(ev));
            this.datoseventos = eventosSinSimulador;
            this.eventos = eventosSinSimulador;
            // Tipos / subtipos
            this.tipos = resTipos.data.tipos;
            this.subtipos = resTipos.data.subtipos;
            // Colegios
            this.colegios = resColegios.data.colegios;
            this.todos_colegios = resColegios.data.colegios;
            // Usuarios
            this.usuarios = resUsuarios.data.usuarios;

            // Si venimos desde Inicio/Calendario/Análisis, abrir el evento seleccionado automáticamente.
            this.abrirEventoPendienteDesdeStorage();
        }).catch(err => {
            console.error('Error cargando datos iniciales', err);
        }).finally(() => {
            this.isLoading = false;
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <loading-message v-if="isLoading" :progress="uploadProgress" />
            <div class="col-12">
                <div class="card" style="overflow:visible;">
                    <!-- Header UGM -->
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-calendar font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Eventos</h5>
                            <small class="text-white" style="opacity:.8;">Gestiona y revisa todos los eventos</small>
                        </div>
                    </div>
                    <div class="card-body py-3" style="overflow:visible;">
                        <div class="row justify-content-center">
                            <div class="col-md-8">
                                <label class="font-weight-semibold mb-1" style="color:#252C5F;">
                                    <i class="bx bx-search-alt mr-1"></i> Buscar por nombre o código
                                </label>
                                <multiselect
                                    v-model="eventoseleccionada"
                                    :options="eventos"
                                    :custom-label="labelEvento"
                                    placeholder="Ej: Charla de Carreras o ACT-2026-001..."
                                    selectLabel="Seleccionar"
                                    selectedLabel="✓"
                                    deselectLabel="Remover"
                                    track-by="codigo"
                                    :searchable="true"
                                    :filterable="true"
                                    @select="onSelectEvento"
                                >
                                    <template v-slot:noOptions><span class="text-muted">Sin resultados disponibles</span></template>
                                    <template v-slot:noResult><span class="text-muted">No se encontraron coincidencias</span></template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ── DETALLE EVENTO ── -->
            <div class="col-12" v-if="eventoseleccionada && eventoid_seleccion1 && eventoid_seleccion1 != ''">
                <div class="card">
                    <!-- Sub-header con nombre y botones -->
                    <div class="card-header py-3 d-flex align-items-center justify-content-between"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <div>
                            <h5 class="text-white mb-0">
                                <i class="bx bx-calendar mr-2"></i>{{ eventoid_seleccion1.nombre_difusion }}
                            </h5>
                            <small class="text-white" style="opacity:.8;">
                                <code style="background:rgba(255,255,255,.15);color:#fff;border-radius:4px;padding:1px 7px;">{{ eventoid_seleccion1.codigo }}</code>
                                &nbsp;·&nbsp;
                                <template v-if="colegiosDetalleEvento.length > 1">
                                    {{ colegiosDetalleEvento.map(c => c.nombre).join(', ') }}
                                </template>
                                <template v-else>
                                    {{ eventoid_seleccion1.colegio }} (RBD {{ eventoid_seleccion1.rbd_colegio }})
                                </template>
                            </small>
                        </div>
                        <div class="d-flex" style="gap:8px;">
                            <button @click="buscar_colegio()" class="btn-ugm-white">
                                <i class="bx bx-buildings mr-1"></i> {{ colegiosDetalleEvento.length > 1 ? 'Ver Colegios' : 'Ver Colegio' }}
                            </button>
                            <button
                                v-if="puedeVerPreviewCorreo"
                                @click="enviarPreviewCorreoEvento('creacion_evento')"
                                class="btn-ugm-white">
                                <i class="bx bx-mail-send mr-1"></i>
                                {{ isSendingPreview ? 'Generando...' : 'Preview correo' }}
                            </button>
                            <button v-if="puedeEliminarEventos && !editing"
                                @click="eliminar(eventoid_seleccion1.id)"
                                class="btn-ugm-danger">
                                <i class="bx bx-trash"></i>
                            </button>
                            <button v-if="editing && puedeEditarEventos" @click="cancelEdit" class="btn-ugm-white">
                                <i class="fas fa-times mr-1"></i> Cancelar
                            </button>
                            <button @click="toggleEdit" :class="editing ? 'btn-ugm-gold' : 'btn-ugm-white'" v-if="puedeEditarEventos">
                                <i :class="editing ? 'fas fa-save' : 'fas fa-edit'" class="mr-1"></i>
                                {{ editing ? 'Guardar cambios' : 'Editar' }}
                            </button>
                        </div>
                    </div>

                    <div class="card-body pt-4">

                        <!-- ── MODO VISTA ── -->
                        <div v-if="!editing">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="d-flex align-items-center mb-3">
                                        <div style="width:4px;height:20px;background:#252C5F;border-radius:2px;margin-right:8px;"></div>
                                        <span class="font-weight-bold" style="color:#252C5F;">Información del Evento</span>
                                    </div>
                                    <table class="table table-sm table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td class="font-weight-bold text-dark" style="width:45%">Actividad</td>
                                                <td>{{ eventoid_seleccion1.nombre_difusion }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Código</td>
                                                <td><code>{{ eventoid_seleccion1.codigo }}</code></td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Fecha Inicio</td>
                                                <td>{{ eventoid_seleccion1.fecha_inicio }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Fecha Término</td>
                                                <td>{{ eventoid_seleccion1.fecha_termino }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Tipo</td>
                                                <td>{{ eventoid_seleccion1.tipo_nombre }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Subtipo</td>
                                                <td>{{ eventoid_seleccion1.subtipo_nombre }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Curso</td>
                                                <td>{{ eventoid_seleccion1.cursos }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">RBD</td>
                                                <td>
                                                    <template v-if="colegiosDetalleEvento.length > 1">
                                                        <span v-for="(col, i) in colegiosDetalleEvento" :key="'rbd-'+col.rbd">
                                                            <span @click="ver_colegio(col.rbd)"
                                                                style="cursor:pointer;color:#252C5F;text-decoration:underline;">
                                                                {{ col.rbd }}
                                                                <i class="bx bx-link-external ml-1" style="font-size:.8rem;"></i>
                                                            </span><span v-if="i < colegiosDetalleEvento.length - 1">, </span>
                                                        </span>
                                                    </template>
                                                    <template v-else>
                                                        <span @click="ver_colegio(eventoid_seleccion1.rbd_colegio)"
                                                            style="cursor:pointer;color:#252C5F;text-decoration:underline;">
                                                            {{ eventoid_seleccion1.rbd_colegio }}
                                                            <i class="bx bx-link-external ml-1" style="font-size:.8rem;"></i>
                                                        </span>
                                                    </template>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Colegio</td>
                                                <td>
                                                    <template v-if="colegiosDetalleEvento.length > 1">
                                                        <span v-for="(col, i) in colegiosDetalleEvento" :key="col.rbd">
                                                            {{ col.nombre }} <small class="text-muted">({{ col.rbd }})</small><span v-if="i < colegiosDetalleEvento.length - 1">, </span>
                                                        </span>
                                                    </template>
                                                    <template v-else>{{ eventoid_seleccion1.colegio }}</template>
                                                </td>
                                            </tr>
                                            <tr v-if="direccionesColegiosDetalle.length">
                                                <td class="font-weight-bold text-dark">Dirección</td>
                                                <td>
                                                    <template v-if="direccionesColegiosDetalle.length > 1">
                                                        <span v-for="(col, i) in direccionesColegiosDetalle" :key="'dir-'+col.rbd">
                                                            {{ col.direccion }} <small class="text-muted">({{ col.rbd }})</small><span v-if="i < direccionesColegiosDetalle.length - 1">, </span>
                                                        </span>
                                                    </template>
                                                    <template v-else>{{ direccionColegio }}</template>
                                                </td>
                                            </tr>
                                            <tr v-if="eventoid_seleccion1.landing_asistencia">
                                                <td class="font-weight-bold text-dark">Landing Asistencia</td>
                                                <td>
                                                    {{ eventoid_seleccion1.landing_asistencia }}
                                                    <b-button size="sm" @click="copiarLink(eventoid_seleccion1.landing_asistencia)" class="ml-1 p-0 px-1" style="background:transparent;border:none;color:#252C5F;">
                                                        <i class="bx bx-copy-alt"></i>
                                                    </b-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-6">
                                    <div class="d-flex align-items-center mb-3">
                                        <div style="width:4px;height:20px;background:#61B7E4;border-radius:2px;margin-right:8px;"></div>
                                        <span class="font-weight-bold" style="color:#252C5F;">Datos Operacionales</span>
                                    </div>
                                    <table class="table table-sm table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td class="font-weight-bold text-dark" style="width:50%">Estado</td>
                                                <td>
                                                    <span v-if="estadoActividadLabel"
                                                        class="badge"
                                                        style="background:#252C5F;color:#fff;font-size:.8rem;padding:4px 10px;border-radius:12px;">
                                                        {{ estadoActividadLabel }}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Asistentes por Curso</td>
                                                <td>
                                                    <div v-if="Object.keys(asistentesDetalle).length">
                                                        <div v-for="(n, curso) in asistentesDetalle" :key="curso" class="d-flex" style="gap:6px;margin-bottom:2px;">
                                                            <span style="color:#555;min-width:110px;font-size:.82rem;">{{ curso }}</span>
                                                            <span class="badge" style="background:#61B7E4;color:#fff;border-radius:10px;padding:2px 8px;font-size:.78rem;">{{ n != null ? n : '—' }}</span>
                                                        </div>
                                                        <div class="mt-1 pt-1" style="border-top:1px solid #e9ecef;">
                                                            <span class="font-weight-bold" style="font-size:.82rem;color:#252C5F;">Total: </span>
                                                            <span class="badge" style="background:#252C5F;color:#fff;border-radius:10px;padding:2px 8px;font-size:.78rem;">{{ totalAsistentes }}</span>
                                                        </div>
                                                    </div>
                                                    <span v-else class="text-muted" style="font-size:.82rem;">Sin registrar</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Coordinador Evento</td>
                                                <td>{{ eventoid_seleccion1.coordinador_evento && typeof eventoid_seleccion1.coordinador_evento === 'object' ? eventoid_seleccion1.coordinador_evento.name : eventoid_seleccion1.coordinador_evento }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Responsable</td>
                                                <td>{{ eventoid_seleccion1.propietario && typeof eventoid_seleccion1.propietario === 'object' ? eventoid_seleccion1.propietario.name : eventoid_seleccion1.propietario }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Fecha Creación</td>
                                                <td>{{ eventoid_seleccion1.fecha_creacion }}</td>
                                            </tr>
                                            <tr v-if="fechaModificacion">
                                                <td class="font-weight-bold text-dark">Última Modificación</td>
                                                <td>{{ fechaModificacion }}</td>
                                            </tr>
                                            <tr v-if="eventoid_seleccion1.observaciones">
                                                <td class="font-weight-bold text-dark">Observaciones</td>
                                                <td>{{ eventoid_seleccion1.observaciones }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">HubSpot</td>
                                                <td>
                                                    <div class="d-flex align-items-center" style="gap:8px;flex-wrap:wrap;">
                                                        <span v-if="eventoid_seleccion1.hubspot_actividad_id"
                                                            class="badge badge-pill badge-success">
                                                            <i class="bx bx-check mr-1"></i>Sincronizado
                                                        </span>
                                                        <span v-else class="badge badge-pill badge-secondary">
                                                            <i class="bx bx-minus mr-1"></i>No sincronizado
                                                        </span>
                                                        <b-button v-if="puedeEditarEventos" size="sm" class="d-inline-flex align-items-center"
                                                            style="background:#252C5F;border-color:#252C5F;color:#fff;font-size:11px;"
                                                            :disabled="syncingEventoHubspot" @click="syncHubspotEvento()">
                                                            <i :class="syncingEventoHubspot ? 'bx bx-loader bx-spin mr-1' : 'bx bx-refresh mr-1'"></i>
                                                            {{ syncingEventoHubspot ? 'Sincronizando...' : 'Reintentar sync' }}
                                                        </b-button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="eventoid_seleccion1.landing_inscripcion">
                                                <td class="font-weight-bold text-dark">Landing Inscripción</td>
                                                <td>
                                                    {{ eventoid_seleccion1.landing_inscripcion }}
                                                    <b-button size="sm" @click="copiarLink(eventoid_seleccion1.landing_inscripcion)" class="ml-1 p-0 px-1" style="background:transparent;border:none;color:#252C5F;">
                                                        <i class="bx bx-copy-alt"></i>
                                                    </b-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- ── MODO EDICIÓN ── -->
                        <div v-else>
                            <div class="d-flex align-items-center mb-3">
                                <div style="width:4px;height:20px;background:#252C5F;border-radius:2px;margin-right:8px;"></div>
                                <span class="font-weight-bold" style="color:#252C5F;">Datos del Evento</span>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>
                                            Colegio <span class="text-danger">*</span>
                                            <span v-if="colegiosEditSel && colegiosEditSel.length > 1"
                                                class="badge ml-2"
                                                style="background:#252C5F;color:#fff;font-size:0.72rem;border-radius:12px;padding:2px 8px;">
                                                {{ colegiosEditSel.length }} colegios
                                            </span>
                                        </label>
                                        <multiselect v-model="colegiosEditSel" :options="colegios"
                                            track-by="rbd"
                                            :multiple="true"
                                            :close-on-select="false"
                                            placeholder="Seleccionar colegio(s)" selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Remover"
                                            :custom-label="labelselect_colegio">
                                            <template v-slot:noOptions><span class="text-muted">Sin opciones</span></template>
                                            <template v-slot:noResult><span class="text-muted">Sin coincidencias</span></template>
                                        </multiselect>
                                    </div>
                                    <div class="form-group">
                                        <label>Actividad <span class="text-danger">*</span></label>
                                        <input type="text" v-model="eventoid_seleccion.nombre_difusion" class="form-control">
                                    </div>
                                    <div class="form-group">
                                        <label>Código <span class="text-danger">*</span></label>
                                        <input type="text" v-model="eventoid_seleccion.codigo" class="form-control">
                                    </div>
                                    <div class="form-group">
                                        <label>Fecha Inicio <span class="text-danger">*</span></label>
                                        <input type="datetime-local" v-model="eventoid_seleccion.fecha_inicio" class="form-control">
                                    </div>
                                    <div class="form-group">
                                        <label>Fecha de Término <span class="text-danger">*</span></label>
                                        <input type="datetime-local" v-model="eventoid_seleccion.fecha_termino" class="form-control">
                                    </div>
                                    <div class="form-group">
                                        <label>Tipo <span class="text-danger">*</span></label>
                                        <multiselect v-model="eventoid_seleccion.tipo" :options="tipos.filter(t => t.codigo != null)"
                                            placeholder="Seleccionar tipo" selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Remover"
                                            :custom-label="labelselect_tipo" @select="ver_subtipo()">
                                            <template v-slot:noOptions><span class="text-muted">Sin opciones</span></template>
                                            <template v-slot:noResult><span class="text-muted">Sin coincidencias</span></template>
                                        </multiselect>
                                    </div>
                                    <div class="form-group">
                                        <label>Subtipo <span class="text-danger">*</span></label>
                                        <multiselect v-model="eventoid_seleccion.subtipo" :options="subtiposfilter"
                                            placeholder="Seleccionar subtipo" selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Remover"
                                            :custom-label="labelselect_tipo">
                                            <template v-slot:noOptions><span class="text-muted">Sin opciones</span></template>
                                            <template v-slot:noResult><span class="text-muted">Sin coincidencias</span></template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Curso y N° Asistentes <span class="text-danger">*</span></label>
                                        <div class="d-flex flex-wrap" style="gap:8px;">
                                            <div v-for="c in cursos" :key="c"
                                                @click="toggleCursoEdit(c)"
                                                :style="isCursoSelectedEdit(c)
                                                    ? 'background:#252C5F;color:#fff;border:2px solid #252C5F;border-radius:6px;padding:4px 10px;cursor:pointer;font-size:0.82rem;font-weight:600;'
                                                    : 'background:#f4f6fb;color:#252C5F;border:2px solid #dee2e6;border-radius:6px;padding:4px 10px;cursor:pointer;font-size:0.82rem;'">
                                                {{ c }}
                                            </div>
                                        </div>
                                        <div v-if="eventoid_seleccion.curso_multi && eventoid_seleccion.curso_multi.length" class="mt-2">
                                            <div v-for="c in eventoid_seleccion.curso_multi" :key="'edit-asi-'+c" class="d-flex align-items-center mb-1" style="gap:8px;">
                                                <span style="min-width:130px;font-size:0.82rem;color:#252C5F;font-weight:500;">{{ c }}</span>
                                                <b-form-input
                                                    type="number"
                                                    min="0"
                                                    v-model.number="eventoid_seleccion.asistentes_por_curso[c]"
                                                    placeholder="N° asistentes"
                                                    size="sm"
                                                    style="max-width:130px;" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Estado <span class="text-danger">*</span></label>
                                        <multiselect v-model="eventoid_seleccion.estado_actividad" :options="estados_eventos"
                                            placeholder="Seleccionar estado" selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Remover"
                                            :custom-label="labelselect_tipo">
                                            <template v-slot:noOptions><span class="text-muted">Sin opciones</span></template>
                                            <template v-slot:noResult><span class="text-muted">Sin coincidencias</span></template>
                                        </multiselect>
                                    </div>
                                    <div class="form-group">
                                        <label>Observaciones</label>
                                        <textarea v-model="eventoid_seleccion.observaciones" class="form-control" rows="3" placeholder="Observaciones del evento..."></textarea>
                                    </div>
                                    <div class="form-group">
                                        <label>Coordinador Evento</label>
                                        <multiselect v-model="eventoid_seleccion.coordinador_evento" :options="usuarios"
                                            placeholder="Seleccionar usuario" selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Remover"
                                            :custom-label="labelselect_usuarios">
                                            <template v-slot:noOptions><span class="text-muted">Sin opciones</span></template>
                                            <template v-slot:noResult><span class="text-muted">Sin coincidencias</span></template>
                                        </multiselect>
                                    </div>
                                    <div class="form-group">
                                        <label>Responsable</label>
                                        <multiselect v-model="eventoid_seleccion.propietario" :options="usuarios"
                                            placeholder="Seleccionar usuario" selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Remover"
                                            :custom-label="labelselect_usuarios">
                                            <template v-slot:noOptions><span class="text-muted">Sin opciones</span></template>
                                            <template v-slot:noResult><span class="text-muted">Sin coincidencias</span></template>
                                        </multiselect>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- ── TABS ── -->
                        <div class="mt-4">
                            <b-tabs content-class="mt-3" class="tabs-order-custom">
                                <b-tab title="Laborantes" title-item-class="tab-order-laborantes">
                                    <laborantesEvento
                                        :evento-codigo="eventoid_seleccion1 && eventoid_seleccion1.codigo ? eventoid_seleccion1.codigo : null"
                                        :allow-redirect="false"
                                        :read-only="!puedeGestionarDetalleEvento"
                                    />
                                </b-tab>
                                <b-tab title="Pagos Laborantes" v-if="pagosLaborantesPagados.length" disabled>
                                    <div class="table-responsive mb-0 mt-2">
                                        <table class="table table-hover">
                                            <thead style="background:#252C5F;color:#fff;">
                                                <tr>
                                                    <th class="font-weight-normal py-2 pl-3" style="width:5%">Nº</th>
                                                    <th class="font-weight-normal py-2" style="width:20%">Nombre</th>
                                                    <th class="font-weight-normal py-2" style="width:20%">RUT</th>
                                                    <th class="font-weight-normal py-2" style="width:20%">Monto</th>
                                                    <th class="font-weight-normal py-2" style="width:15%">Estado</th>
                                                    <th class="font-weight-normal py-2" style="width:20%">Fecha Pago</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, idx) in pagosLaborantesPagados" :key="item.id || idx">
                                                    <td class="pl-3">{{ idx + 1 }}</td>
                                                    <td>{{ item.name || '-' }}</td>
                                                    <td>{{ item.rut || '-' }}</td>
                                                    <td>{{ formatCLP(item.monto) }}</td>
                                                    <td>{{ item.estado || '-' }}</td>
                                                    <td>{{ item.fecha_pago || '-' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-tab>
                                <b-tab title="Gastos" title-item-class="tab-order-gastos">
                                    <div class="row mb-3">
                                        <div class="col-md-12 text-right">
                                            <button v-if="puedeGestionarDetalleEvento && !showGastoForm" class="btn-ugm-gold" @click="toggleGastoForm">
                                                <i class="bx bx-plus mr-1"></i> Agregar gasto
                                            </button>
                                            <button v-else-if="puedeGestionarDetalleEvento" class="btn-ugm-white" @click="toggleGastoForm">Cancelar</button>
                                        </div>
                                    </div>
                                    <div v-if="puedeGestionarDetalleEvento && showGastoForm" class="card mb-3" style="border:1px solid #e9ecef;">
                                        <div class="card-header py-2 d-flex align-items-center" style="background:#f8f9fa;">
                                            <div style="width:4px;height:16px;background:#CB9700;border-radius:2px;margin-right:8px;"></div>
                                            <span class="font-weight-bold" style="color:#252C5F;font-size:.9rem;">Nuevo gasto</span>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label class="font-weight-semibold" style="color:#252C5F;">Tipo de gasto <span class="text-danger">*</span></label>
                                                        <multiselect v-model="gasto.tipo" :options="tipos_gastos"
                                                            placeholder="Seleccionar tipo" selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Remover">
                                                            <template v-slot:noOptions><span class="text-muted">Sin opciones</span></template>
                                                            <template v-slot:noResult><span class="text-muted">Sin coincidencias</span></template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label class="font-weight-semibold" style="color:#252C5F;">Monto del Gasto <span class="text-danger">*</span></label>
                                                        <b-form-input v-model="gasto.monto" @keydown="restrictToNumbers" @input="format_Valor"></b-form-input>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label class="font-weight-semibold" style="color:#252C5F;">Documento Asociado</label>
                                                        <b-form-file v-model="gasto.imagen" accept="image/*,application/pdf"
                                                            placeholder="Elegir Archivo" drop-placeholder="Arrastra el archivo aquí..."
                                                            @change="obtenerImagen" browse-text="Examinar"></b-form-file>
                                                    </div>
                                                </div>
                                                <div class="col-md-12 text-right">
                                                    <button class="btn-ugm-dark" @click="validaciones">
                                                        <i class="bx bx-save mr-1"></i> Guardar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-3" v-if="gastosEvento.length">
                                        <div class="d-flex align-items-center mb-3">
                                            <div style="width:4px;height:18px;background:#CB9700;border-radius:2px;margin-right:8px;"></div>
                                            <span class="font-weight-bold" style="color:#252C5F;">Gastos registrados</span>
                                        </div>
                                        <div class="table-responsive">
                                            <table class="table table-hover">
                                                <thead style="background:#252C5F;color:#fff;">
                                                    <tr>
                                                        <th class="font-weight-normal py-2 pl-3" style="width:5%">Nº</th>
                                                        <th class="font-weight-normal py-2" style="width:15%">Tipo Gasto</th>
                                                        <th class="font-weight-normal py-2" style="width:15%">Monto</th>
                                                        <th class="font-weight-normal py-2" style="width:20%">Comprobante</th>
                                                        <th v-if="puedeGestionarDetalleEvento" class="font-weight-normal py-2" style="width:20%">Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(g, idx) in gastosEvento" :key="g.id || idx">
                                                        <td class="pl-3">{{ ((asistentesPage - 1) * asistentesPerPage) + idx + 1 }}</td>
                                                        <td>{{ g.tipo_gasto }}</td>
                                                        <td>{{ formatCLP(g.monto) }}</td>
                                                        <td>
                                                            <b-button variant="primary" @click="ver_comprobante(g)" size="sm">Ver</b-button>
                                                        </td>
                                                        <td v-if="puedeGestionarDetalleEvento">
                                                            <b-button variant="primary" @click="modal_editar(g)" size="sm">Editar</b-button>
                                                            <b-button variant="danger" @click="eliminar_gasto(g)" size="sm"><i class="bx bx-trash"></i></b-button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <b-modal ref="modal-imagen" title="Comprobante de Gasto" ok-only ok-title="Cerrar">
                                            <div v-if="extension=='pdf'"><pdf :src="direccion"></pdf></div>
                                            <img :src="direccion" width="100%" v-else>
                                        </b-modal>
                                        <b-modal v-if="puedeGestionarDetalleEvento" ref="modal-editar" title="Editar Gasto" ok-title="Guardar" cancel-title="Cancelar" @ok="editar">
                                            <div class="row mt-4">
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Tipo de gasto</label>
                                                        <multiselect v-model="valor_editar.tipo" :options="tipos_gastos"
                                                            placeholder="Seleccionar tipo" selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Remover">
                                                            <template v-slot:noOptions><span class="text-muted">Sin opciones</span></template>
                                                            <template v-slot:noResult><span class="text-muted">Sin coincidencias</span></template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Monto del Gasto</label>
                                                        <b-form-input v-model="valor_editar.monto" @input="format_Valor"></b-form-input>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <b-button :variant="cambiar?'secondary':'primary'" @click="btn_cambiar">{{ cambiar ? 'No Cambiar' : 'Cambiar Documento' }}</b-button>
                                                    <div v-if="!cambiar">
                                                        <pdf :src="direccion" v-if="extension=='pdf'"></pdf>
                                                        <img :src="direccion" width="100%" v-else>
                                                    </div>
                                                    <div class="row" v-else>
                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <label>Documento Asociado</label>
                                                                <b-form-file v-model="valor_editar.imagen" accept="image/*,application/pdf"
                                                                    placeholder="Elegir Archivo" drop-placeholder="Arrastra el archivo aquí..."
                                                                    @change="obtenerImagenEditar" browse-text="Examinar"></b-form-file>
                                                            </div>
                                                        </div>
                                                        <div class="offset-md-1 col-md-10 text-center">
                                                            <figure v-if="tipoArchivo === 'imagen'">
                                                                <img :src="imagenminiatura" height="auto" alt="Imagen del producto">
                                                            </figure>
                                                            <div v-if="tipoArchivo === 'pdf'">
                                                                <pdf :src="imagenminiatura"></pdf>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-modal>
                                    </div>
                                    <div v-else class="text-center text-muted py-3" style="border:1px dashed #dee2e6;border-radius:8px;">
                                        <i class="bx bx-receipt font-size-20 d-block mb-1"></i>
                                        No hay gastos registrados para este evento.
                                    </div>
                                </b-tab>
                                <b-tab title="Asistentes" title-item-class="tab-order-asistentes" active>
                                    <!-- Barra de acciones -->
                                    <div class="d-flex justify-content-between align-items-center mb-3">
                                        <p class="text-uppercase font-size-11 font-weight-bold mb-0" style="color:#252C5F; letter-spacing:.06em;">
                                            <i class="mdi mdi-account-group mr-1"></i>Lista de Asistentes
                                        </p>
                                        <div style="gap:8px;" class="d-flex">
                                            <button v-if="puedeGestionarDetalleEvento" class="btn-ugm-white" @click="descargarPlantillaAsistentes">
                                                <i class="mdi mdi-download mr-1"></i>Descargar plantilla
                                            </button>
                                            <button v-if="puedeGestionarDetalleEvento && eventoid_seleccion1 && eventoid_seleccion1.id"
                                                class="btn-ugm-danger"
                                                :disabled="isDeletingAsistentes || importacionAsistentesActiva || !asistentesYaCargados"
                                                @click="eliminarTodosAsistentesEvento">
                                                <span v-if="isDeletingAsistentes" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                                <i v-else class="mdi mdi-delete mr-1"></i>{{ isDeletingAsistentes ? 'Eliminando...' : 'Eliminar asistentes' }}
                                            </button>
                                            <button v-if="puedeGestionarDetalleEvento && !showUploadAsistentes && !importacionAsistentesActiva" class="btn-ugm-dark" @click="toggleUploadAsistentes">
                                                <i class="mdi mdi-upload mr-1"></i>{{ asistentesYaCargados ? 'Completar lista' : 'Cargar Asistentes' }}
                                            </button>
                                        </div>
                                    </div>
                                    <div v-if="importacionAsistentesActiva" class="p-3 mb-3" style="background:#fff8e1;border-left:4px solid #CB9700;">
                                        <div class="d-flex justify-content-between mb-2">
                                            <strong style="color:#252C5F;">Importación en segundo plano</strong>
                                            <span>{{ importacionAsistentes.porcentaje || 0 }}%</span>
                                        </div>
                                        <b-progress :value="importacionAsistentes.porcentaje || 0" :max="100" height="10px"></b-progress>
                                        <div class="small text-muted mt-2">{{ importacionAsistentes.mensaje }} {{ importacionAsistentes.procesados || 0 }} de {{ importacionAsistentes.total || '?' }} filas.</div>
                                    </div>
                                    <!-- Aviso lista ya cargada -->
                                    <div v-if="asistentesYaCargados" class="d-flex align-items-center p-2 mb-3 rounded" style="background:#e8f4fd; border-left:4px solid #61B7E4;">
                                        <i class="mdi mdi-information-outline mr-2" style="color:#61B7E4;"></i>
                                        <span class="font-size-13" style="color:#252C5F;">Este evento ya tiene una lista cargada. Solo se permite una carga por evento.</span>
                                    </div>
                                    <!-- Subir archivo -->
                                    <div v-if="puedeGestionarDetalleEvento && showUploadAsistentes && !importacionAsistentesActiva" class="card mb-3" style="border:1px solid #e9ecef;">
                                        <div class="card-header py-2 d-flex align-items-center" style="background:#f8f9fa;">
                                            <div style="width:4px;height:16px;background:#CB9700;border-radius:2px;margin-right:8px;"></div>
                                            <span class="font-weight-bold" style="color:#252C5F;font-size:.9rem;">Subir lista de asistentes (.xlsx / .xls / .csv)</span>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <b-form-file ref="asistentesFileInput" :key="asistentesFileKey"
                                                        v-model="selectedAsistentesFile" accept=".xlsx,.xls,.csv"
                                                        placeholder="Elegir Archivo" drop-placeholder="Arrastra el archivo aquí..."
                                                        @change="onFileChange" browse-text="Examinar"></b-form-file>
                                                </div>
                                                <div class="col-md-4 d-flex align-items-end" style="gap:8px;">
                                                    <button class="btn-ugm-dark" @click="uploadAsistentes" :disabled="!selectedAsistentesFile">
                                                        <i class="mdi mdi-upload mr-1"></i>Subir
                                                    </button>
                                                    <button class="btn-ugm-white" @click="toggleUploadAsistentes">
                                                        <i class="mdi mdi-close mr-1"></i>Cancelar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Tabla asistentes -->
                                    <div class="d-flex flex-wrap align-items-center mb-2" style="gap:8px;">
                                        <span class="badge" style="background:#252C5F;color:#fff;padding:6px 10px;font-size:.78rem;">
                                            Almacenados: {{ asistentesAlmacenados }}
                                        </span>
                                        <template v-if="importacionAsistentesActiva">
                                            <span class="badge badge-info" style="padding:6px 10px;font-size:.78rem;">Procesados: {{ importacionAsistentes.procesados || 0 }}</span>
                                            <span class="badge badge-secondary" style="padding:6px 10px;font-size:.78rem;">Total archivo: {{ importacionAsistentes.total || '?' }}</span>
                                            <span v-if="importacionAsistentes.ya_existentes" class="badge badge-warning" style="padding:6px 10px;font-size:.78rem;">Ya existían: {{ importacionAsistentes.ya_existentes }}</span>
                                            <span v-if="importacionAsistentes.detectados_previos > asistentesAlmacenados" class="badge badge-light" style="padding:6px 10px;font-size:.78rem;">Detectados previamente: {{ importacionAsistentes.detectados_previos }}</span>
                                        </template>
                                    </div>
                                    <div v-if="asistentesYaCargados" class="mb-3" style="max-width:420px;">
                                        <b-input-group>
                                            <b-input-group-prepend is-text><i class="mdi mdi-magnify"></i></b-input-group-prepend>
                                            <b-form-input v-model.trim="asistentesSearch" placeholder="Buscar por nombre, RUT o email" @input="buscarAsistentes"></b-form-input>
                                        </b-input-group>
                                        <small v-if="asistentesSearch" class="text-muted">{{ asistentesResultadosTotal }} resultados</small>
                                    </div>
                                    <div v-if="mostrarSpinnerAsistentes" class="text-center text-muted py-4" style="border:1px dashed #dee2e6;border-radius:8px;">
                                        <div class="spinner-border spinner-border-sm mr-2" style="color:#252C5F;" role="status"></div>
                                        Cargando asistentes...
                                    </div>
                                    <div v-else-if="eventoid_seleccion1 && eventoid_seleccion1.asistentes && eventoid_seleccion1.asistentes.length">
                                        <div class="table-responsive mt-2">
                                            <table class="table table-hover">
                                                <thead style="background:#252C5F;color:#fff;">
                                                    <tr>
                                                        <th class="font-weight-normal py-2 pl-3" style="width:5%">Nº</th>
                                                        <th class="font-weight-normal py-2" style="min-width:120px;">RUT</th>
                                                        <th class="font-weight-normal py-2" style="min-width:220px;">Nombre</th>
                                                        <th class="font-weight-normal py-2" style="min-width:170px;">Apellido paterno</th>
                                                        <th class="font-weight-normal py-2" style="min-width:170px;">Apellido materno</th>
                                                        <th class="font-weight-normal py-2 text-center" style="min-width:150px;">Acción HubSpot</th>
                                                        <th class="font-weight-normal py-2" style="min-width:120px;">Curso</th>
                                                        <th class="font-weight-normal py-2" style="min-width:170px;">Colegio</th>
                                                        <th class="font-weight-normal py-2" style="min-width:140px;">Celular</th>
                                                        <th class="font-weight-normal py-2" style="min-width:220px;">Email</th>
                                                        <th class="font-weight-normal py-2" style="min-width:170px;">Preferencia 1</th>
                                                        <th class="font-weight-normal py-2" style="min-width:170px;">Preferencia 2</th>
                                                        <th class="font-weight-normal py-2" style="min-width:170px;">Preferencia 3</th>
                                                        <th class="font-weight-normal py-2" style="min-width:190px;">Preferencia extra</th>
                                                        <th class="font-weight-normal py-2" style="min-width:190px;">Preferencia extra 2</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(a, idx) in eventoid_seleccion1.asistentes" :key="idx">
                                                        <td class="pl-3">{{ ((asistentesPage - 1) * asistentesPerPage) + idx + 1 }}</td>
                                                        <td>{{ a.rut || '-' }}</td>
                                                        <td>{{ a.nombres || a.nombre || '-' }}</td>
                                                        <td>{{ a.apellido_paterno || '-' }}</td>
                                                        <td>{{ a.apellido_materno || '-' }}</td>
                                                        <td class="text-center">
                                                            <span v-if="a.hubspot_sync_action === 'created'" class="badge badge-primary" :title="`Contacto creado y asociado en HubSpot${a.hubspot_contact_id ? ` (ID ${a.hubspot_contact_id})` : ''}`">
                                                                <i class="mdi mdi-account-plus mr-1"></i>Creado
                                                            </span>
                                                            <span v-else-if="a.hubspot_sync_action === 'associated'" class="badge badge-info" :title="`Contacto ya asociado a la actividad en HubSpot${a.hubspot_contact_id ? ` (ID ${a.hubspot_contact_id})` : ''}`">
                                                                <i class="mdi mdi-link mr-1"></i>Asociado
                                                            </span>
                                                            <span v-else-if="a.hubspot_sync_action === 'existing'" class="badge badge-success" :title="`Contacto existente reutilizado y asociado en HubSpot${a.hubspot_contact_id ? ` (ID ${a.hubspot_contact_id})` : ''}`">
                                                                <i class="mdi mdi-account-check mr-1"></i>Reutilizado
                                                            </span>
                                                            <span v-else-if="a.hubspot_sync_action === 'association_error'" class="badge badge-danger" :title="a.hubspot_sync_error || 'El contacto fue encontrado, pero falló una asociación en HubSpot'">
                                                                <i class="mdi mdi-link-off mr-1"></i>Error asociación
                                                            </span>
                                                            <span v-else-if="a.hubspot_sync_action === 'error' || a.hubspot_sync_action === 'create_failed'" class="badge badge-danger" :title="a.hubspot_sync_error || 'No se pudo sincronizar el contacto en HubSpot'">
                                                                <i class="mdi mdi-close-thick mr-1"></i>Error
                                                            </span>
                                                            <span v-else-if="a.hubspot_sync_action === 'pending'" class="badge badge-warning" :title="a.hubspot_sync_error || 'Pendiente de sincronizar cuando el evento tenga actividad en HubSpot'">
                                                                <i class="mdi mdi-clock-outline mr-1"></i>Pendiente
                                                            </span>
                                                            <span v-else-if="a.hubspot_contact_id" class="badge badge-success" :title="`Sincronizado en HubSpot${a.hubspot_contact_id ? ` (ID ${a.hubspot_contact_id})` : ''}`">
                                                                <i class="mdi mdi-check-bold mr-1"></i>Sincronizado
                                                            </span>
                                                            <span v-else class="badge badge-secondary" :title="a.hubspot_sync_error || 'Sin acción de HubSpot registrada'">
                                                                <i class="mdi mdi-minus-circle-outline mr-1"></i>Sin acción
                                                            </span>
                                                        </td>
                                                        <td>{{ a.curso || '-' }}</td>
                                                        <td>{{ a.establecimiento || '-' }}</td>
                                                        <td>{{ a.celular || '-' }}</td>
                                                        <td>{{ a.email || '-' }}</td>
                                                        <td>{{ mostrarPreferenciaAsistente(a, 'preferencia_1') }}</td>
                                                        <td>{{ mostrarPreferenciaAsistente(a, 'preferencia_2') }}</td>
                                                        <td>{{ mostrarPreferenciaAsistente(a, 'preferencia_3') }}</td>
                                                        <td>{{ mostrarPreferenciaAsistente(a, 'preferencia_extra') }}</td>
                                                        <td>{{ mostrarPreferenciaAsistente(a, 'preferencia_extra_2') }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div v-if="asistentesLastPage > 1" class="d-flex flex-wrap justify-content-between align-items-center mt-3" style="gap:8px;">
                                                <span class="small text-muted">Mostrando {{ ((asistentesPage - 1) * asistentesPerPage) + 1 }}–{{ Math.min(asistentesPage * asistentesPerPage, asistentesResultadosTotal) }} de {{ asistentesResultadosTotal }}</span>
                                                <b-pagination v-model="asistentesPage" :total-rows="asistentesResultadosTotal" :per-page="asistentesPerPage" size="sm" class="mb-0" @input="cargarPaginaAsistentes"></b-pagination>
                                            </div>
                                            <div class="small text-muted mt-2">
                                                <strong>Estados HubSpot:</strong>
                                                <span class="ml-2"><b class="text-primary">Creado</b>: contacto nuevo creado y asociado por esta carga.</span>
                                                <span class="ml-2"><b class="text-success">Reutilizado</b>: contacto existente actualizado y asociado por esta carga.</span>
                                                <span class="ml-2"><b class="text-info">Asociado</b>: contacto existente que ya estaba asociado a la actividad.</span>
                                                <span class="ml-2"><b class="text-success">Sincronizado</b>: hay contacto remoto, pero no se registró una acción más específica.</span>
                                                <span class="ml-2"><b class="text-danger">Error asociación</b>: contacto sincronizado, pero falló una asociación.</span>
                                                <span class="ml-2"><b class="text-danger">Error</b>: no se pudo sincronizar el contacto.</span>
                                                <span class="ml-2"><b class="text-warning">Pendiente</b>: el evento aún no tiene actividad HubSpot.</span>
                                                <span class="ml-2"><b class="text-secondary">Sin acción</b>: no hay resultado registrado.</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="asistentesSearch && asistentesYaCargados" class="text-center text-muted py-4" style="border:1px dashed #dee2e6;border-radius:8px;">
                                        No se encontraron asistentes para “{{ asistentesSearch }}”.
                                    </div>
                                    <div v-else-if="!showUploadAsistentes && !asistentesYaCargados" class="text-center text-muted py-4" style="border:1px dashed #dee2e6;border-radius:8px;">
                                        <i class="mdi mdi-account-group font-size-24 d-block mb-2" style="color:#CB9700;"></i>
                                        No hay asistentes registrados para este evento.
                                    </div>
                                </b-tab>

                                <!-- ── TAB INSUMOS ── -->
                                <b-tab title="Insumos" title-item-class="tab-order-insumos">
                                    <div class="row mb-3">
                                        <div class="col-md-12 text-right">
                                            <template v-if="puedeGestionarInsumos">
                                                <button v-if="!showInsumoForm" class="btn-ugm-gold" @click="toggleInsumoForm">
                                                    <i class="bx bx-plus mr-1"></i> Agregar insumo
                                                </button>
                                                <button v-else class="btn-ugm-white" @click="toggleInsumoForm">Cancelar</button>
                                            </template>
                                        </div>
                                    </div>
                                    <!-- Formulario nuevo insumo -->
                                    <div v-if="puedeGestionarInsumos && showInsumoForm" class="card mb-3" style="border:1px solid #e9ecef;">
                                        <div class="card-header py-2 d-flex align-items-center" style="background:#f8f9fa;">
                                            <div style="width:4px;height:16px;background:#CB9700;border-radius:2px;margin-right:8px;"></div>
                                            <span class="font-weight-bold" style="color:#252C5F;font-size:.9rem;">Nuevo insumo</span>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-5">
                                                    <div class="form-group">
                                                        <label class="font-weight-semibold" style="color:#252C5F;">Nombre <span class="text-danger">*</span></label>
                                                        <b-form-input v-model="insumo.nombre" placeholder="Ej: Folletos, Lapiceros..." />
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="font-weight-semibold" style="color:#252C5F;">Cantidad <span class="text-danger">*</span></label>
                                                        <b-form-input v-model.number="insumo.cantidad" type="number" min="0" step="1" placeholder="0" />
                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <label class="font-weight-semibold" style="color:#252C5F;">Unidad</label>
                                                        <b-form-input v-model="insumo.unidad" placeholder="Ej: unid, caja..." />
                                                    </div>
                                                </div>
                                                <div class="col-md-2 d-flex align-items-end">
                                                    <div class="form-group w-100">
                                                        <label class="font-weight-semibold d-block" style="color:transparent;">.</label>
                                                        <button class="btn-ugm-dark w-100" @click="agregarInsumo" :disabled="isSavingInsumo">
                                                            <i class="bx bx-check mr-1"></i> {{ isSavingInsumo ? 'Guardando...' : 'Guardar' }}
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label class="font-weight-semibold" style="color:#252C5F;">Observación</label>
                                                        <b-form-textarea v-model="insumo.observacion" rows="2" placeholder="Opcional..." />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Tabla insumos -->
                                    <div v-if="insumosEvento.length">
                                        <div class="table-responsive mt-2">
                                            <table class="table table-hover">
                                                <thead style="background:#252C5F;color:#fff;">
                                                    <tr>
                                                        <th class="font-weight-normal py-2 pl-3" style="width:5%">Nº</th>
                                                        <th class="font-weight-normal py-2" style="width:35%">Nombre</th>
                                                        <th class="font-weight-normal py-2" style="width:15%">Cantidad</th>
                                                        <th class="font-weight-normal py-2" style="width:15%">Unidad</th>
                                                        <th class="font-weight-normal py-2" style="width:25%">Observación</th>
                                                        <th v-if="puedeGestionarInsumos" class="font-weight-normal py-2" style="width:5%"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, idx) in insumosEvento" :key="item.id || idx">
                                                        <td class="pl-3">{{ idx + 1 }}</td>
                                                        <td>{{ item.nombre }}</td>
                                                        <td>{{ item.cantidad }}</td>
                                                        <td>{{ item.unidad || '-' }}</td>
                                                        <td>{{ item.observacion || '-' }}</td>
                                                        <td v-if="puedeGestionarInsumos">
                                                            <button v-if="puedeGestionarInsumos" class="btn btn-sm btn-link text-danger p-0" @click="eliminarInsumo(item.id, idx)" title="Eliminar">
                                                                <i class="bx bx-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div v-else-if="!showInsumoForm" class="text-center text-muted py-4" style="border:1px dashed #dee2e6;border-radius:8px;">
                                        <i class="bx bx-package font-size-24 d-block mb-2" style="color:#CB9700;"></i>
                                        No hay insumos registrados para este evento.
                                    </div>
                                </b-tab>

                            </b-tabs>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </Layout>
</template>
                                <div class="card mt-3 shadow-sm border-light">
                                    <div class="card-body">
                                        <div class="row" v-if="eventoid_seleccion!=''">
                                            <div class="col-md-12">
                                                <b-button class="float-right" variant="primary" @click="buscar_colegio()">Volver Colegio</b-button>
                                            </div>
                                            <div class="col-md-12">
                                                <h1 class="text-primary mb-4">Evento: {{ editing ?  eventoid_seleccion.nombre_difusion : eventoid_seleccion.nombre_difusion }}</h1>
                                                <h2 class="text-primary">Colegio: {{ editing ?  eventoid_seleccion.colegio : eventoid_seleccion.colegio }}</h2>
                                                <h3 class="text-primary">RBD: {{ editing ?  eventoid_seleccion.rbd_colegio : eventoid_seleccion.rbd_colegio }}</h3>
                                                <div class="row" v-if="editing">
                                                    <div class="col-md-6">
                                                        <div class="form-group row" >
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Colegio:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect
                                                                    v-model="colegiosEditSel"
                                                                    :options="colegios"
                                                                    track-by="rbd"
                                                                    :multiple="true"
                                                                    :close-on-select="false"
                                                                    placeholder="Seleccionar colegio(s)"
                                                                    selectLabel="Seleccionar"
                                                                    selectedLabel="✓"
                                                                    deselectLabel="Remover"
                                                                    :custom-label="labelselect_colegio">
                                                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <input type="text" id="pais" v-model="eventoid_seleccion.colegio" class="form-control border-primary"> -->
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Actividad:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="pais" v-model="eventoid_seleccion.nombre_difusion" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Código:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="name" v-model="eventoid_seleccion.codigo" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <!-- <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Área:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="name" v-model="eventoid_seleccion.area" class="form-control border-primary">
                                                            </div>
                                                        </div> -->
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Fecha inicio:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="datetime-local" id="direccion" v-model="eventoid_seleccion.fecha_inicio" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Fecha de término:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="datetime-local" id="ciudad" v-model="eventoid_seleccion.fecha_termino" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono">Tipo:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary">* Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <!-- <p>{{ eventoid_seleccion.tipo }}</p> -->
                                                                <multiselect v-model="eventoid_seleccion.tipo"
                                                                    :options="tipos.filter(t => t.codigo != null)"
                                                                    placeholder="Seleccionar tipo"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="labelselect_tipo"
                                                                    @select="ver_subtipo()">
                                                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <select
                                                                    v-model="eventoid_seleccion.tipo"
                                                                    class="form-control border-primary"
                                                                >
                                                                    <option disabled value="">Seleccionar tipo</option>
                                                                    <option v-for="tipo in tipos.filter(t => t.codigo != null)" :key="tipo.codigo" :value="tipo.codigo">
                                                                        {{ tipo.nombre }}
                                                                    </option>
                                                                </select> -->
                                                            </div>
                                                        </div>

                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono">Subtipo:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary">* Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <!-- <p>{{ eventoid_seleccion.subtipo }}</p> -->
                                                                <multiselect v-model="eventoid_seleccion.subtipo"
                                                                    :options="subtiposfilter"
                                                                    placeholder="Seleccionar subtipo"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="labelselect_tipo" >
                                                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <select
                                                                    v-model="eventoid_seleccion.subtipo"
                                                                    class="form-control border-primary"
                                                                >
                                                                    <option disabled value="">Seleccionar subtipo</option>
                                                                    <option v-for="subtipo in subtipos.filter(sub=>sub.tipo_codigo==eventoid_seleccion.tipo)" :key="subtipo.codigo" :value="subtipo.codigo">
                                                                        {{ subtipo.nombre }}
                                                                    </option>
                                                                </select> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Curso:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect
                                                                    v-model="eventoid_seleccion.curso_multi"
                                                                    :options="cursos"
                                                                    :close-on-select="false"
                                                                    placeholder="Seleccionar curso"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :multiple="true"
                                                                    >
                                                                    <template v-slot:noOptions>
                                                                        <p>No hay opciones</p>
                                                                    </template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <input type="text" id="telefono" v-model="eventoid_seleccion.curso" class="form-control border-primary"> -->
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="estado"> Estado:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="estado" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect v-model="eventoid_seleccion.estado_actividad"
                                                                    :options="estados_eventos"
                                                                    placeholder="Seleccionar estado"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="labelselect_tipo" >
                                                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <select
                                                                    id="estado"
                                                                    v-model="eventoid_seleccion.estado_actividad"
                                                                    class="form-control border-primary"
                                                                >
                                                                    <option disabled value="">Seleccionar estado</option>
                                                                    <option v-for="estado in estados_eventos" :key="estado.id" :value="estado.codigo">
                                                                        {{ estado.nombre }}
                                                                    </option>
                                                                </select> -->
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Nombre para Difusión Digital:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="email" id="email" v-model="eventoid_seleccion.nombre_difusion" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Coordinador evento:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect
                                                                    v-model="eventoid_seleccion.coordinador_evento"
                                                                    :options="usuarios"
                                                                    placeholder="Seleccionar usuario"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="labelselect_usuarios"
                                                                    >
                                                                    <template v-slot:noOptions>
                                                                        <p>No hay opciones</p>
                                                                    </template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <input type="email" id="email" v-model="eventoid_seleccion.coordinador_evento" class="form-control border-primary"> -->
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="email"> Responsable:</label>
                                                            <multiselect
                                                                v-model="eventoid_seleccion.propietario"
                                                                :options="usuarios"
                                                                placeholder="Seleccionar usuario"
                                                                selectLabel="Presiona para seleccionar"
                                                                selectedLabel="Seleccionado"
                                                                deselectLabel="Presiona para remover"
                                                                :custom-label="labelselect_usuarios"
                                                                >
                                                                <template v-slot:noOptions>
                                                                    <p>No hay opciones</p>
                                                                </template>
                                                                <template v-slot:noResult>
                                                                    <p>No se encuentra coincidencia</p>
                                                                </template>
                                                            </multiselect>
                                                            <!-- <input type="email" id="email" v-model="eventoid_seleccion.propietario" class="form-control border-primary"> -->
                                                        </div>
                                                    </div>
                                                    <div class="offset-md-9 col-md-3 mb-3">
                                                        <div class="mt-3 float-right">
                                                            <button v-if="editing" @click="cancelEdit" class="btn btn-secondary">
                                                                <i class="fas fa-times"></i> Cancelar
                                                            </button>
                                                            <button @click="toggleEdit" class="btn btn-primary">
                                                                <i :class="editing ? 'fas fa-save' : 'fas fa-edit'"></i> {{ editing ? 'Guardar cambios' : 'Editar.' }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-else>
                                                    <div class="col-md-6" >
                                                        <b-button variant="primary" @click="correo_agradecimiento" v-if="false"><i class="bx bx-send font-size-14"></i> Enviar agradecimiento</b-button>
                                                        <b-button
                                                            v-if="user && user.rol!='Laborante'"
                                                            variant="warning"
                                                            class="ml-2"
                                                            @click="enviarPreviewCorreoEvento('creacion_evento')"
                                                        >
                                                            <i class="bx bx-mail-send font-size-14"></i>
                                                            {{ isSendingPreview ? 'Generando preview...' : 'Preview correo' }}
                                                        </b-button>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="mt-3 float-right">
                                                            <b-button v-if="editing" @click="cancelEdit" variant="primary">
                                                                <i class="fas fa-times"></i> Cancelar
                                                            </b-button>
                                                            <b-button @click="toggleEdit" variant="primary">
                                                                <i :class="editing ? 'fas fa-save' : 'fas fa-edit'"></i> {{ editing ? 'Guardar cambios' : 'Editar..' }}
                                                            </b-button>
                                                            <b-button variant="danger" @click="eliminar(eventoid_seleccion1.id)" v-if="user.id=='6' || user.id=='1'"><i class="bx bx-trash"></i></b-button>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="offset-md-6 col-md-6 mb-2">
                                                        <div class="mt-3 float-right">
                                                            <label for="">Estado:</label>
                                                            <multiselect
                                                                v-model="estado"
                                                                :options="estados"
                                                                placeholder="Selecciona estado"
                                                                selectLabel="Presiona para seleccionar"
                                                                selectedLabel="Seleccionado"
                                                                deselectLabel="Presiona para remover"
                                                                @select="cambio_estado"
                                                                :close-on-select="true"
                                                                >
                                                                <template v-slot:noOptions>
                                                                    <p>No hay opciones</p>
                                                                </template>
                                                                <template v-slot:noResult>
                                                                    <p>No se encuentra coincidencia</p>
                                                                </template>
                                                            </multiselect>
                                                        </div>
                                                    </div> -->
                                                    <div class="col-md-6">
                                                        <p class="font-size-16"><strong>Actividad:</strong> {{ eventoid_seleccion1.nombre_difusion }}</p>
                                                        <p class="font-size-16"><strong>Código:</strong> {{ eventoid_seleccion1.codigo }}</p>
                                                        <!-- <p class="font-size-16"><strong>Área:</strong> {{ eventoid_seleccion.area }}</p> -->
                                                        <p class="font-size-16"><strong>Fecha Inicio:</strong> {{ eventoid_seleccion1.fecha_inicio }}</p><!--con hora -->
                                                        <p class="font-size-16"><strong>Fecha de término:</strong> {{ eventoid_seleccion1.fecha_termino }}</p>
                                                        <p class="font-size-16"><strong>Tipo:</strong> {{ eventoid_seleccion1.tipo_nombre}}</p>
                                                        <p class="font-size-16"><strong>Subtipo:</strong> {{ eventoid_seleccion1.subtipo_nombre }}</p>
                                                        <p class="font-size-16"><strong>Curso:</strong>
                                                            {{ eventoid_seleccion1.cursos}}
                                                        </p>
                                                        <p class="font-size-16">
                                                            <strong>RBD:</strong>
                                                            <template v-if="colegiosDetalleEvento.length > 1">
                                                                <span v-for="(col, i) in colegiosDetalleEvento" :key="'mobile-rbd-'+col.rbd">
                                                                    <span @click="ver_colegio(col.rbd)" style="cursor: pointer; text-decoration: underline; color:#252C5F;">{{ col.rbd }}</span><i class="bx bx-link ml-1 mr-1"></i><span v-if="i < colegiosDetalleEvento.length - 1">, </span>
                                                                </span>
                                                            </template>
                                                            <template v-else>
                                                                <span @click="ver_colegio(eventoid_seleccion1.rbd_colegio)" style="cursor: pointer; text-decoration: underline; color:#252C5F;">{{ eventoid_seleccion1.rbd_colegio }}</span>
                                                                <i class="bx bx-link ml-2"></i>
                                                            </template>
                                                        </p>
                                                        <p class="font-size-16"><strong>Colegio:</strong>
                                                            <template v-if="colegiosDetalleEvento.length > 1">
                                                                <span v-for="(col, i) in colegiosDetalleEvento" :key="col.rbd">
                                                                    {{ col.nombre }} <small class="text-muted">({{ col.rbd }})</small><span v-if="i < colegiosDetalleEvento.length - 1">, </span>
                                                                </span>
                                                            </template>
                                                            <template v-else>{{ eventoid_seleccion1.colegio }}</template>
                                                        </p>
                                                        <p class="font-size-16" v-if="direccionesColegiosDetalle.length"><strong>Dirección:</strong>
                                                            <template v-if="direccionesColegiosDetalle.length > 1">
                                                                <span v-for="(col, i) in direccionesColegiosDetalle" :key="'mobile-dir-'+col.rbd">
                                                                    {{ col.direccion }} <small class="text-muted">({{ col.rbd }})</small><span v-if="i < direccionesColegiosDetalle.length - 1">, </span>
                                                                </span>
                                                            </template>
                                                            <template v-else>{{ direccionColegio }}</template>
                                                        </p>
                                                        <p class="font-size-16">
                                                            <strong>Landing Asistencia:</strong>
                                                            {{ eventoid_seleccion1.landing_asistencia }}
                                                            <b-button size="sm" @click="copiarLink(eventoid_seleccion1.landing_asistencia)" v-if="eventoid_seleccion1.landing_asistencia!=null"><i class="bx bx-copy-alt"></i></b-button>
                                                        </p>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <p class="font-size-16"><strong>Nombre para Difusión Digital:</strong> {{ eventoid_seleccion1.nombre_difusion }}</p>
                                                        <p class="font-size-16">
                                                            <strong>Asistentes por Curso:</strong>
                                                            <span v-if="Object.keys(asistentesDetalle).length">
                                                                <span v-for="(n, curso) in asistentesDetalle" :key="curso" class="mr-2">
                                                                    {{ curso }}: <strong>{{ n != null ? n : '—' }}</strong>
                                                                </span>
                                                                (Total: <strong>{{ totalAsistentes }}</strong>)
                                                            </span>
                                                            <span v-else class="text-muted">Sin registrar</span>
                                                        </p>
                                                        <p class="font-size-16"><strong>Responsable:</strong> {{ eventoid_seleccion1.propietario }}</p>
                                                        <p class="font-size-16"><strong>Estado de la actividad:</strong> {{ estadoActividadLabel }}</p>
                                                        <p class="font-size-16"><strong>Coordinador Evento:</strong> {{ eventoid_seleccion1.coordinador_evento!=''?eventoid_seleccion1.coordinador_evento :''}}</p>
                                                        <p class="font-size-16"><strong>Fecha Creación:</strong> {{ eventoid_seleccion1.fecha_creacion }}</p>
                                                        <p class="font-size-16" v-if="fechaModificacion"><strong>Última Modificación:</strong> {{ fechaModificacion }}</p>
                                                        <p class="font-size-16">
                                                            <strong>Landing Inscripción:</strong>
                                                            {{ eventoid_seleccion1.landing_inscripcion }}
                                                            <b-button size="sm" @click="copiarLink(eventoid_seleccion1.landing_inscripcion)" v-if="eventoid_seleccion1.landing_inscripcion!=null"><i class="bx bx-copy-alt"></i></b-button>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div>
                                                    <b-tabs content-class="mt-3" class="tabs-order-custom">
                                                        <b-tab title="Laborantes" title-item-class="tab-order-laborantes">
                                                            <laborantesEvento
                                                                :evento-codigo="eventoid_seleccion1 && eventoid_seleccion1.codigo ? eventoid_seleccion1.codigo : null"
                                                                :allow-redirect="false"
                                                                :read-only="!puedeGestionarDetalleEvento"
                                                            />
                                                            <!-- <div v-if="eventoid_seleccion1 && eventoid_seleccion1.laborantes && eventoid_seleccion1.laborantes.length">
                                                                <ul class="list-group">
                                                                    <li class="list-group-item" v-for="(l, idx) in eventoid_seleccion1.laborantes" :key="idx">
                                                                        {{ l.name || l.nombre || l }}
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div v-else>
                                                                <p class="text-muted">No hay laborantes registrados para este evento.</p>
                                                            </div> -->
                                                        </b-tab>
                                                        <b-tab title="Pagos Laborantes" v-if="pagosLaborantesPagados.length" title-item-class="tab-order-pagos-laborantes">
                                                            <div class="table-responsive mb-0 mt-2">
                                                                <table class="table table-hover">
                                                                    <thead>
                                                                        <tr>
                                                                            <th style="width: 5%;">Nº</th>
                                                                            <th style="width: 20%;">Nombre</th>
                                                                            <th style="width: 20%;">Rut</th>
                                                                            <th style="width: 20%;">Monto</th>
                                                                            <th style="width: 15%;">Estado</th>
                                                                            <th style="width: 20%;">Fecha Pago</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(item, idx) in pagosLaborantesPagados" :key="item.id || idx">
                                                                            <td>{{ idx + 1 }}</td>
                                                                            <td>{{ item.name || '-' }}</td>
                                                                            <td>{{ item.rut || '-' }}</td>
                                                                            <td>{{ formatCLP(item.monto) }}</td>
                                                                            <td>{{ item.estado || '-' }}</td>
                                                                            <td>{{ item.fecha_pago || '-' }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </b-tab>
                                                        <b-tab title="Gastos" title-item-class="tab-order-gastos">
                                                            <div class="row mb-3">
                                                                <div class="col-md-12 text-right">
                                                                    <b-button v-if="puedeGestionarDetalleEvento && !showGastoForm" variant="primary" @click="toggleGastoForm">Agregar gasto</b-button>
                                                                    <b-button v-else-if="puedeGestionarDetalleEvento" variant="secondary" @click="toggleGastoForm">Cancelar</b-button>
                                                                </div>
                                                            </div>
                                                            <div class="row" v-if="puedeGestionarDetalleEvento && showGastoForm">
                                                                <div class="offset-md-2 col-md-8">
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <div class="form-group row">
                                                                                <div class="col-md-6">
                                                                                    <label for="pais"> Tipo de gasto:</label>
                                                                                </div>
                                                                                <div class="col-md-12">
                                                                                    <multiselect
                                                                                        v-model="gasto.tipo"
                                                                                        :options="tipos_gastos"
                                                                                        placeholder="Seleccionar tipo"
                                                                                        selectLabel="Presiona para seleccionar"
                                                                                        selectedLabel="Seleccionado"
                                                                                        deselectLabel="Presiona para remover"
                                                                                        >
                                                                                        <template v-slot:noOptions>
                                                                                            <p>No hay opciones</p>
                                                                                        </template>
                                                                                        <template v-slot:noResult>
                                                                                            <p>No se encuentra coincidencia</p>
                                                                                        </template>
                                                                                    </multiselect>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <div class="form-group row">
                                                                                <div class="col-md-6">
                                                                                    <label for="pais"> Monto del Gasto:</label>
                                                                                </div>
                                                                                <div class="col-md-12">
                                                                                    <b-form-input v-model="gasto.monto" class="border-primary" @keydown="restrictToNumbers" @input="format_Valor"></b-form-input>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <div class="form-group row">
                                                                                <div class="col-md-6">
                                                                                    <label for="pais"> Documento Asociado:</label>
                                                                                </div>
                                                                                <div class="col-md-12">
                                                                                    <b-form-file
                                                                                        v-model="gasto.imagen"
                                                                                        class="form-control border-primary"
                                                                                        accept="image/*,application/pdf"
                                                                                        placeholder="Elegir Archivo"
                                                                                        drop-placeholder="Arrastra el archivo aquí..."
                                                                                        @change="obtenerImagen"
                                                                                        browse-text="Examinar"
                                                                                    ></b-form-file>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-12 text-right">
                                                                            <b-button variant="primary" @click="validaciones">Guardar</b-button>
                                                                        </div>
                                                                        <div class="offset-md-1 col-md-10 text-center">
                                                                            <!-- Mostrar imagen si el archivo es imagen -->
                                                                            <figure v-if="tipoArchivo === 'imagen'">
                                                                                <img :src="imagenminiatura" height="400" alt="Imagen del producto">
                                                                            </figure>
                                                                            <!-- Mostrar PDF si el archivo es PDF -->
                                                                            <div v-if="tipoArchivo === 'pdf'">
                                                                                <pdf :src="imagenminiatura"></pdf>
                                                                                <!----> <embed :src="imagenminiatura" type="application/pdf" width="100%" height="500px" /> -->
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mt-3" v-if="gastosEvento.length">
                                                                <div class="col-md-12">
                                                                    <h5 class="text-primary mb-3">Gastos registrados</h5>
                                                                    <div class="table-responsive mb-0 mt-2">
                                                                        <table class="table table-hover">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th style="width: 5%;">Nº</th>
                                                                                    <th style="width: 8%;">Tipo Gasto</th>
                                                                                    <th style="width: 10%;">Monto</th>
                                                                                    <th style="width: 20%;">Comprobante</th>
                                                                                    <th v-if="puedeGestionarDetalleEvento" style="width: 20%;">Acciones</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr v-for="(g, idx) in gastosEvento" :key="g.id || idx">
                                                                                    <td>{{ idx + 1 }}</td>
                                                                                    <td>{{ g.tipo_gasto }}</td>
                                                                                    <td>{{ formatCLP(g.monto) }}</td>
                                                                                    <td>
                                                                                        <b-button variant="primary" @click="ver_comprobante(g)" size="sm">Ver</b-button>
                                                                                    </td>
                                                                                    <td v-if="puedeGestionarDetalleEvento">
                                                                                        <b-button variant="primary" @click="modal_editar(g)">Editar</b-button>
                                                                                        <b-button variant="danger" @click="eliminar_gasto(g)"><i class="bx bx-trash"></i></b-button>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                        <b-modal ref="modal-imagen" title="Comprobante de Gasto" ok-only ok-title="Cerrar">
                                                                            <div v-if="extension=='pdf'">
                                                                                <pdf :src="direccion"></pdf>
                                                                            </div>
                                                                            <img :src="direccion" width="100%" v-else>
                                                                        </b-modal>
                                                                        <b-modal ref="modal-editar" title="Editar Gasto" ok-title="Guardar" cancel-title="Cancelar" @ok="editar">
                                                                            <div class="row mt-4">
                                                                                <div class="col-md-12">
                                                                                    <div class="form-group row">
                                                                                        <div class="col-md-6">
                                                                                            <label for="pais"> Tipo de gasto:</label>
                                                                                        </div>
                                                                                        <div class="col-md-12">
                                                                                            <multiselect
                                                                                                v-model="valor_editar.tipo"
                                                                                                :options="tipos_gastos"
                                                                                                placeholder="Seleccionar tipo"
                                                                                                selectLabel="Presiona para seleccionar"
                                                                                                selectedLabel="Seleccionado"
                                                                                                deselectLabel="Presiona para remover"
                                                                                                >
                                                                                                <template v-slot:noOptions>
                                                                                                    <p>No hay opciones</p>
                                                                                                </template>
                                                                                                <template v-slot:noResult>
                                                                                                    <p>No se encuentra coincidencia</p>
                                                                                                </template>
                                                                                            </multiselect>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-12">
                                                                                    <div class="form-group row">
                                                                                        <div class="col-md-6">
                                                                                            <label for="pais"> Monto del Gasto:</label>
                                                                                        </div>
                                                                                        <div class="col-md-12">
                                                                                            <b-form-input v-model="valor_editar.monto" class="border-primary" @input="format_Valor"></b-form-input>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-12">
                                                                                    <b-button :variant="cambiar?'secondary':'primary'" @click="btn_cambiar">{{ cambiar ? 'No Cambiar' : 'Cambiar Documento'}}</b-button>
                                                                                    <div v-if="!cambiar">
                                                                                        <pdf :src="direccion" v-if="extension=='pdf'"></pdf>
                                                                                        <img :src="direccion" width="100%" v-else>
                                                                                    </div>
                                                                                    <div class="row" v-else>
                                                                                        <div class="col-md-12">
                                                                                            <div class="form-group row">
                                                                                                <div class="col-md-6">
                                                                                                    <label for="pais"> Documento Asociado:</label>
                                                                                                </div>
                                                                                                <div class="col-md-12">
                                                                                                    <b-form-file
                                                                                                        v-model="valor_editar.imagen"
                                                                                                        class="form-control border-primary"
                                                                                                        accept="image/*,application/pdf"
                                                                                                        placeholder="Elegir Archivo"
                                                                                                        drop-placeholder="Arrastra el archivo aquí..."
                                                                                                        @change="obtenerImagenEditar"
                                                                                                        browse-text="Examinar"
                                                                                                    ></b-form-file>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="offset-md-1 col-md-10 text-center">
                                                                                            <figure v-if="tipoArchivo === 'imagen'">
                                                                                                <img :src="imagenminiatura" height="auto" alt="Imagen del producto">
                                                                                            </figure>
                                                                                            <div v-if="tipoArchivo === 'pdf'">
                                                                                                <pdf :src="imagenminiatura"></pdf>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </b-modal>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-else class="text-center text-muted">
                                                                <p>No hay gastos registrados para este evento.</p>
                                                            </div>
                                                        </b-tab>
                                                        <b-tab title="Asistentes" title-item-class="tab-order-asistentes" active>
                                                            <div class="d-flex justify-content-between align-items-center mb-3">
                                                                <p class="text-uppercase font-size-11 font-weight-bold mb-0" style="color:#252C5F; letter-spacing:.06em;">
                                                                    <i class="mdi mdi-account-group mr-1"></i>Lista de Asistentes
                                                                </p>
                                                                <div style="gap:8px;" class="d-flex">
                                                                    <button v-if="puedeGestionarDetalleEvento" class="btn-ugm-white" @click="descargarPlantillaAsistentes">
                                                                        <i class="mdi mdi-download mr-1"></i>Descargar plantilla
                                                                    </button>
                                                                    <button v-if="puedeGestionarDetalleEvento && eventoid_seleccion1 && eventoid_seleccion1.id"
                                                                        class="btn-ugm-danger"
                                                                        :disabled="isDeletingAsistentes || importacionAsistentesActiva || !asistentesYaCargados"
                                                                        @click="eliminarTodosAsistentesEvento">
                                                                        <span v-if="isDeletingAsistentes" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                                                        <i v-else class="mdi mdi-delete mr-1"></i>{{ isDeletingAsistentes ? 'Eliminando...' : 'Eliminar asistentes' }}
                                                                    </button>
                                                                    <button v-if="puedeGestionarDetalleEvento && !showUploadAsistentes && !importacionAsistentesActiva" class="btn-ugm-dark" @click="toggleUploadAsistentes">
                                                                        <i class="mdi mdi-upload mr-1"></i>{{ asistentesYaCargados ? 'Completar lista' : 'Cargar Asistentes' }}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div v-if="importacionAsistentesActiva" class="p-3 mb-3" style="background:#fff8e1;border-left:4px solid #CB9700;">
                                                                <div class="d-flex justify-content-between mb-2">
                                                                    <strong style="color:#252C5F;">Importación en segundo plano</strong>
                                                                    <span>{{ importacionAsistentes.porcentaje || 0 }}%</span>
                                                                </div>
                                                                <b-progress :value="importacionAsistentes.porcentaje || 0" :max="100" height="10px"></b-progress>
                                                                <div class="small text-muted mt-2">{{ importacionAsistentes.mensaje }} {{ importacionAsistentes.procesados || 0 }} de {{ importacionAsistentes.total || '?' }} filas.</div>
                                                            </div>
                                                            <div v-if="asistentesYaCargados" class="d-flex align-items-center p-2 mb-3 rounded" style="background:#e8f4fd; border-left:4px solid #61B7E4;">
                                                                <i class="mdi mdi-information-outline mr-2" style="color:#61B7E4;"></i>
                                                                <span class="font-size-13" style="color:#252C5F;">Este evento ya tiene una lista cargada. Solo se permite una carga por evento.</span>
                                                            </div>
                                                            <div v-if="puedeGestionarDetalleEvento && showUploadAsistentes && !importacionAsistentesActiva" class="card mb-3" style="border:1px solid #e9ecef;">
                                                                <div class="card-header py-2 d-flex align-items-center" style="background:#f8f9fa;">
                                                                    <div style="width:4px;height:16px;background:#CB9700;border-radius:2px;margin-right:8px;"></div>
                                                                    <span class="font-weight-bold" style="color:#252C5F;font-size:.9rem;">Subir lista de asistentes (.xlsx / .xls / .csv)</span>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div class="row">
                                                                        <div class="col-md-8">
                                                                            <b-form-file ref="asistentesFileInput" :key="asistentesFileKey"
                                                                                v-model="selectedAsistentesFile" accept=".xlsx,.xls,.csv"
                                                                                placeholder="Elegir Archivo" drop-placeholder="Arrastra el archivo aquí..."
                                                                                @change="onFileChange" browse-text="Examinar"></b-form-file>
                                                                        </div>
                                                                        <div class="col-md-4 d-flex align-items-end" style="gap:8px;">
                                                                            <button class="btn-ugm-dark" @click="uploadAsistentes" :disabled="!selectedAsistentesFile">
                                                                                <i class="mdi mdi-upload mr-1"></i>Subir
                                                                            </button>
                                                                            <button class="btn-ugm-white" @click="toggleUploadAsistentes">
                                                                                <i class="mdi mdi-close mr-1"></i>Cancelar
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex flex-wrap align-items-center mb-2" style="gap:8px;">
                                                                <span class="badge" style="background:#252C5F;color:#fff;padding:6px 10px;font-size:.78rem;">
                                                                    Almacenados: {{ asistentesAlmacenados }}
                                                                </span>
                                                                <template v-if="importacionAsistentesActiva">
                                                                    <span class="badge badge-info" style="padding:6px 10px;font-size:.78rem;">Procesados: {{ importacionAsistentes.procesados || 0 }}</span>
                                                                    <span class="badge badge-secondary" style="padding:6px 10px;font-size:.78rem;">Total archivo: {{ importacionAsistentes.total || '?' }}</span>
                                                                    <span v-if="importacionAsistentes.ya_existentes" class="badge badge-warning" style="padding:6px 10px;font-size:.78rem;">Ya existían: {{ importacionAsistentes.ya_existentes }}</span>
                                                                    <span v-if="importacionAsistentes.detectados_previos > asistentesAlmacenados" class="badge badge-light" style="padding:6px 10px;font-size:.78rem;">Detectados previamente: {{ importacionAsistentes.detectados_previos }}</span>
                                                                </template>
                                                            </div>
                                                            <div v-if="asistentesYaCargados" class="mb-3" style="max-width:420px;">
                                                                <b-input-group>
                                                                    <b-input-group-prepend is-text><i class="mdi mdi-magnify"></i></b-input-group-prepend>
                                                                    <b-form-input v-model.trim="asistentesSearch" placeholder="Buscar por nombre, RUT o email" @input="buscarAsistentes"></b-form-input>
                                                                </b-input-group>
                                                                <small v-if="asistentesSearch" class="text-muted">{{ asistentesResultadosTotal }} resultados</small>
                                                            </div>
                                                            <div v-if="mostrarSpinnerAsistentes" class="text-center text-muted py-4" style="border:1px dashed #dee2e6;border-radius:8px;">
                                                                <div class="spinner-border spinner-border-sm mr-2" style="color:#252C5F;" role="status"></div>
                                                                Cargando asistentes...
                                                            </div>
                                                            <div v-else-if="eventoid_seleccion1 && eventoid_seleccion1.asistentes && eventoid_seleccion1.asistentes.length">
                                                                <div class="table-responsive mt-2">
                                                                    <table class="table table-hover">
                                                                        <thead style="background:#252C5F;color:#fff;">
                                                                            <tr>
                                                                                <th class="font-weight-normal py-2 pl-3" style="width:5%">Nº</th>
                                                                                <th class="font-weight-normal py-2" style="min-width:120px;">RUT</th>
                                                                                <th class="font-weight-normal py-2" style="min-width:220px;">Nombre</th>
                                                                                <th class="font-weight-normal py-2" style="min-width:120px;">Curso</th>
                                                                                <th class="font-weight-normal py-2" style="min-width:170px;">Colegio</th>
                                                                                <th class="font-weight-normal py-2" style="min-width:140px;">Celular</th>
                                                                                <th class="font-weight-normal py-2" style="min-width:220px;">Email</th>
                                                                                <th class="font-weight-normal py-2" style="min-width:170px;">Preferencia 1</th>
                                                                                <th class="font-weight-normal py-2" style="min-width:170px;">Preferencia 2</th>
                                                                                <th class="font-weight-normal py-2" style="min-width:170px;">Preferencia 3</th>
                                                                                <th class="font-weight-normal py-2" style="min-width:190px;">Preferencia extra</th>
                                                                                <th class="font-weight-normal py-2" style="min-width:190px;">Preferencia extra 2</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(a, idx) in eventoid_seleccion1.asistentes" :key="idx">
                                                                                <td class="pl-3">{{ ((asistentesPage - 1) * asistentesPerPage) + idx + 1 }}</td>
                                                                                <td>{{ a.rut || '-' }}</td>
                                                                                <td>{{ a.nombres || a.nombre || a.name || '-' }}</td>
                                                                                <td>{{ a.curso || '-' }}</td>
                                                                                <td>{{ a.establecimiento || '-' }}</td>
                                                                                <td>{{ a.celular || '-' }}</td>
                                                                                <td>{{ a.email || '-' }}</td>
                                                                                <td>{{ mostrarPreferenciaAsistente(a, 'preferencia_1') }}</td>
                                                                                <td>{{ mostrarPreferenciaAsistente(a, 'preferencia_2') }}</td>
                                                                                <td>{{ mostrarPreferenciaAsistente(a, 'preferencia_3') }}</td>
                                                                                <td>{{ mostrarPreferenciaAsistente(a, 'preferencia_extra') }}</td>
                                                                                <td>{{ mostrarPreferenciaAsistente(a, 'preferencia_extra_2') }}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <div v-if="asistentesLastPage > 1" class="d-flex flex-wrap justify-content-between align-items-center mt-3" style="gap:8px;">
                                                                        <span class="small text-muted">Mostrando {{ ((asistentesPage - 1) * asistentesPerPage) + 1 }}–{{ Math.min(asistentesPage * asistentesPerPage, asistentesResultadosTotal) }} de {{ asistentesResultadosTotal }}</span>
                                                                        <b-pagination v-model="asistentesPage" :total-rows="asistentesResultadosTotal" :per-page="asistentesPerPage" size="sm" class="mb-0" @input="cargarPaginaAsistentes"></b-pagination>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-else-if="asistentesSearch && asistentesYaCargados" class="text-center text-muted py-4" style="border:1px dashed #dee2e6;border-radius:8px;">
                                                                No se encontraron asistentes para “{{ asistentesSearch }}”.
                                                            </div>
                                                            <div v-else-if="!showUploadAsistentes && !asistentesYaCargados" class="text-center text-muted py-4" style="border:1px dashed #dee2e6;border-radius:8px;">
                                                                <i class="mdi mdi-account-group font-size-24 d-block mb-2" style="color:#CB9700;"></i>
                                                                No hay asistentes registrados para este evento.
                                                            </div>
                                                        </b-tab>
                                                    </b-tabs>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.btn-ugm-white {
    background: #fff !important;
    color: #252C5F !important;
    border: 1px solid #ccd3e0 !important;
    border-radius: 6px;
    padding: 5px 14px;
    font-size: .8rem;
    font-weight: 600;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-white:hover { opacity: .85; }
.btn-ugm-white:disabled { opacity: .5; cursor: not-allowed; }

.btn-ugm-gold {
    background: #CB9700 !important;
    color: #fff !important;
    border: 1px solid #CB9700 !important;
    border-radius: 6px;
    padding: 5px 14px;
    font-size: .8rem;
    font-weight: 600;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-gold:hover { opacity: .88; }

.btn-ugm-danger {
    background: #dc3545 !important;
    color: #fff !important;
    border: 1px solid #dc3545 !important;
    border-radius: 6px;
    padding: 5px 10px;
    font-size: .8rem;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-danger:hover { opacity: .85; }

.btn-ugm-dark {
    background: #252C5F !important;
    color: #fff !important;
    border: 1px solid #252C5F !important;
    border-radius: 6px;
    padding: 6px 16px;
    font-size: .85rem;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-dark:hover { opacity: .85; }

/* Reordenar pestañas: Asistentes, Laborantes, Insumos, Gastos */
.tabs-order-custom /deep/ .nav-tabs {
    display: flex;
}
.tabs-order-custom /deep/ .nav-item.tab-order-asistentes { order: 1; }
.tabs-order-custom /deep/ .nav-item.tab-order-laborantes { order: 2; }
.tabs-order-custom /deep/ .nav-item.tab-order-insumos { order: 3; }
.tabs-order-custom /deep/ .nav-item.tab-order-gastos { order: 4; }
.tabs-order-custom /deep/ .nav-item.tab-order-pagos-laborantes { order: 5; }
</style>
